import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import UserProjects from "../Static Files/UserProjects.json";
import NumberToPersianWord from "number_to_persian_word";
import Select from "react-dropdown-select";
import CustomDropdownWithSearch from "../Components/CustomDropdownWithSearch";
import CustomControl from "../Components/CustomControl";
import { ReactComponent as Logoen } from "../Images/public/logoen.svg";
import { ReactComponent as Logofa } from "../Images/public/logofa.svg";
import GetPrice from "../Functions/GetPrice";
import { useSelector } from "react-redux";
import jwt from "jwt-decode";
import GuestProductList from "../Components/GuestProductList";
import DraperyComponent from "../Components/DraperyComponent";
import ProductTowComponent from "../Components/ProductTowComponent";
import SwatchesComponent from "../Components/SwatchesComponent";
import store from "../store";
import { LOGOUT } from "../Actions/types";
import Modal from "react-bootstrap/Modal";
import ModalLogin from "../Components/ModalLogin";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";
import GetUserProjectData from "../Functions/GetUserProjectData";
import { convertToPersian, NumToFa, formatAddressDigits } from "../Functions/TextTransform";
import { processAndSendOrder } from "../Functions/orderHelper";

import { Accordion, AccordionContext, useAccordionButton } from "react-bootstrap";
import { CapitalizeAllWords } from "../Functions/TextTransform";
import ShowMoreLineLimited from "../Components/ShowMoreLineLimited";
import { useMediaQuery } from "react-responsive";
import {
  imgUrl,
  baseURLPrice,
  baseURLGetAddress,
  baseURLDeleteAddress,
  baseURLEditAddress,
  baseURLAddAddress,
  baseURLGetStates,
  baseURLGetCities,
  baseURLGetCart,
  baseURLAddDiscount,
  baseURLAddDiscountGuest,
  baseURLDeleteDiscount,
  baseURLDeleteDiscount2,
  checkoutPayment,
  baseURLGetShippingMethods,
} from "../config/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function capitalizeFirstLetter(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function Checkout() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { swatchOnly } = useParams();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const firstRender = useRef(true);
  const lastGuestShippingZipRef = useRef("");
  const lastLoggedInShippingAddressIdRef = useRef("");
  const { isLoggedIn, multipleAdded } = useSelector((state) => state.auth);
  let navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const [noShipping, setNoShipping] = useState(false);
  const [subTotalPrice, setSubTotalPrice] = useState(0);
  const [installPrice, setInstallPrice] = useState(0);
  const [transportPrice, setTransportPrice] = useState(0);
  const [shippingPrice, setShippingPrice] = useState(0);
  const [shippingMethods, setShippingMethods] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalSaving, setTotalSaving] = useState(0);
  const [cart, setCart] = useState({});
  const [drapery, setDrapery] = useState([]);
  const [products, setProducts] = useState([]);
  const [product2, setProduct2] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [productGuest, setProductGuest] = useState([]);
  const [swatches, setSwatches] = useState([]);
  const [showSideLoginModal, setShowSideLoginModal] = useState(false);
  const [cartChanged, setCartChanged] = useState(0);
  const [discount, setDiscount] = useState("");
  const [discountErr, setDiscountErr] = useState("");
  const [discountList, setDiscountList] = useState([]);
  const [priceTotal, setPriceTotal] = useState(null);
  const [loginInfo, setLoginInfo] = useState({
    email: "",
    password: "",
    passwordConfirm: "",
  });
  const [emailNews, setEmailNews] = useState(false);
  const [passwordsEnable, setPasswordsEnable] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [showPasswordValidation, setShowPasswordValidation] = useState(false);
  const [showCheckoutPassword, setShowCheckoutPassword] = useState(false);
  const [showCheckoutPasswordConfirm, setShowCheckoutPasswordConfirm] = useState(false);
  const checkoutPasswordRef = useRef(null);
  const checkoutPasswordConfirmRef = useRef(null);
  const checkoutPasswordEditedRef = useRef(false);
  const [passwordValidation, setPasswordValidation] = useState({
    count: false,
    lowercase: false,
    uppercase: false,
    numbers: false,
  });

  const [emailNotValid, setEmailNotValid] = useState(false);
  const [mobileErrorState, setMobileErrorState] = useState(0);
  const [emailErrorState, setEmailErrorState] = useState(0);
  const [firstNotExist, setFirstNotExist] = useState(false);
  const [lastNotExist, setLastNotExist] = useState(false);
  const [emailNotExist, setEmailNotExist] = useState(false);
  const [mobileNotExist, setMobileNotExist] = useState(false);
  const [address1NotExist, setAddress1NotExist] = useState(false);
  const [zipCodeNotExist, setZipCodeNotExist] = useState(false);

  const mobileError = {
    en: [{ error: "Please enter a valid mobile." }, { error: "Please enter a valid mobile." }],
    fa: [
      { error: "لطفا شماره موبایل معتبری وارد کنید." },
      { error: "لطفا شماره موبایل معتبری وارد کنید." },
    ],
  };

  const emailError = {
    en: [
      { error: "Please include an '@' in the email address." },
      { error: "A part following '@' should not contain the symbol '@'." },
      { error: "Please enter a part followed by '@'." },
      { error: "Please enter a part following '@'." },
      { error: "Please include an '.' in the part following '@'." },
      { error: "'.' is used at a wrong position" },
      { error: "Please enter a part followed by '.'." },
      { error: "The email is invalid." },
      { error: "This email address is already associated with an account." },
    ],
    fa: [
      { error: "ایمیل شما بایستی نماد '@' داشته باشد." },
      { error: "بخش پس از '@' نباید دارای نماد '@' باشد." },
      { error: "بخش قبل از '@' را وارد کنید." },
      { error: "بخش پس از '@' را وارد کنید." },
      { error: "لطفا یک '.' را در قسمت بعد '@' وارد کنید." },
      { error: "'.' در مکان نادرستی استفاده شده است." },
      { error: "بخش پس از '.' را وارد کنید." },
      { error: "ایمیل نادرست میباشد." },
      { error: "این آدرس ایمیل با حساب کاربری دیگری مرتبط است." },
    ],
  };

  const [address1, setAddress1] = useState({
    id: "",
    Name: "",
    Last: "",
    Address1: "",
    Address2: "",
    State: "1",
    City: "1",
    ZipCode: "",
    PhoneNumber: "",
  });
  
  const [address2Enable, setAddress2Enable] = useState(false);
  const [address2, setAddress2] = useState({});
  const [bank, setBank] = useState(1);
  const [userAddress, setUserAddress] = useState([]);
  const [hasAddress, setHasAddress] = useState(false);
  const [userAddressRender, setUserAddressRender] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState([]);
  const [addressSelectorExpanded, setAddressSelectorExpanded] = useState(false);
  const [shippingMethodExpanded, setShippingMethodExpanded] = useState(false);
  const [selectedShippingMethodKey, setSelectedShippingMethodKey] = useState(null);
  const [addressMenuOpenId, setAddressMenuOpenId] = useState(null);
  const [showEditAddressModal, setShowEditAddressModal] = useState(false);
  const [editAddressMode, setEditAddressMode] = useState("edit");
  const [showDeleteAddressModal, setShowDeleteAddressModal] = useState(false);
  const [showPaymentSuccessModal, setShowPaymentSuccessModal] = useState(false);
  const [deleteAddressId, setDeleteAddressId] = useState(null);
  const [paymentContinuing, setPaymentContinuing] = useState(false);
  const [editAddressSaving, setEditAddressSaving] = useState(false);
  const [editAddressForm, setEditAddressForm] = useState({
    CustomerAddressId: "",
    Name: "",
    Last: "",
    Address1: "",
    Address2: "",
    ZipCode: "",
    PhoneNumber: "",
    IsDefault: false,
    StateId: "",
    CityId: "",
  });
  const [editSelectedState, setEditSelectedState] = useState([]);
  const [editSelectedCity, setEditSelectedCity] = useState([]);
  const [editCities, setEditCities] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [tempCity, setTempCity] = useState([]);
  const [tempCityId, setTempCityId] = useState(undefined);

  function checkPasswordStrength(user_password) {
    let temp = JSON.parse(JSON.stringify(passwordValidation));
    if (user_password.length > 20) {
    } else if (user_password.length < 8) {
    } else {
      let matchedCase = [];
      matchedCase.push("[A-Z]"); // Uppercase
      matchedCase.push("[a-z]"); // Lowercase
      matchedCase.push("[0-9]"); // Numbers
      let count = 0;
      for (let i = 0; i < matchedCase.length; i++) {
        if (new RegExp(matchedCase[i]).test(user_password)) {
          count++;
        }
      }
      if (count === 3) {
      } else {
      }
    }

    temp.count = user_password.length <= 20 && user_password.length >= 8;

    temp.uppercase = new RegExp("[A-Z]").test(user_password);

    temp.lowercase = new RegExp("[a-z]").test(user_password);

    temp.numbers = new RegExp("[0-9]").test(user_password);

    setPasswordValidation(temp);
  }

  const validateEmail = (email) => {
    if (
      email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/
      )
    ) {
      return true;
    } else {
      if (!email.includes("@")) {
        setEmailErrorState(0);
      } else {
        const myArray = email.split("@");
        if (myArray.length - 1 > 1) {
          setEmailErrorState(1);
        } else if (myArray[0] === "") {
          setEmailErrorState(2);
        } else if (myArray[1] === "") {
          setEmailErrorState(3);
        } else if (!myArray[1].includes(".")) {
          setEmailErrorState(4);
        } else {
          const myArray2 = myArray[1].split(".");
          if (myArray2[0] === "") {
            setEmailErrorState(5);
          } else if (myArray2.pop() === "") {
            setEmailErrorState(6);
          } else {
            setEmailErrorState(7);
          }
        }
        return false;
      }
    }
  };

  function validateNumber(user_number) {
    if (user_number.length !== 11) {
      // setMobileNotExist(true);
      setMobileErrorState(0);
    } else if (!/^0[0-9].*$/.test(user_number)) {
      // setMobileNotExist(true);
      setMobileErrorState(1);
    } else {
      setMobileNotExist(false);
    }
  }

  function resetCheckoutPasswordFields() {
    checkoutPasswordEditedRef.current = false;
    setShowCheckoutPassword(false);
    setShowCheckoutPasswordConfirm(false);
    setShowPasswordValidation(false);
    setPasswordMatch(false);
    setLoginInfo((prev) => ({ ...prev, password: "", passwordConfirm: "" }));
    if (checkoutPasswordRef.current) checkoutPasswordRef.current.value = "";
    if (checkoutPasswordConfirmRef.current) checkoutPasswordConfirmRef.current.value = "";
  }

  useEffect(() => {
    if (!passwordsEnable) {
      checkoutPasswordEditedRef.current = false;
      return;
    }

    resetCheckoutPasswordFields();

    const clearBrowserAutofill = () => {
      if (checkoutPasswordEditedRef.current) return;
      if (checkoutPasswordRef.current?.value) checkoutPasswordRef.current.value = "";
      if (checkoutPasswordConfirmRef.current?.value) checkoutPasswordConfirmRef.current.value = "";
      setLoginInfo((prev) => {
        if (!prev.password && !prev.passwordConfirm) return prev;
        return { ...prev, password: "", passwordConfirm: "" };
      });
    };

    const timers = [50, 150, 350].map((delay) => setTimeout(clearBrowserAutofill, delay));
    return () => timers.forEach(clearTimeout);
  }, [passwordsEnable]);

  function validateInputs() {
    let temp = JSON.parse(JSON.stringify(address1));
    if (temp["Name"] === "") {
      setFirstNotExist(true);
    }
    if (loginInfo.email === "") {
      setEmailNotExist(true);
      setEmailNotValid(false);
    } else if (!validateEmail(loginInfo.email)) {
      setEmailNotExist(false);
      setEmailNotValid(true);
    }
    if (temp["Last"] === "") {
      setLastNotExist(true);
    }
    if (temp["Address1"] === "") {
      setAddress1NotExist(true);
    }
    if (temp["ZipCode"] === "") {
      setZipCodeNotExist(true);
    }
    if (temp["PhoneNumber"] === "") {
      setMobileNotExist(true);
    }

    if (
      temp["Name"] !== "" &&
      temp["Last"] !== "" &&
      temp["Address1"] !== "" &&
      temp["ZipCode"] !== "" &&
      temp["PhoneNumber"] !== ""
    ) {
      return true;
    } else {
      return false;
    }
  }

  function checkDiscount() {
    let discountText = JSON.parse(JSON.stringify(discount));
    if (isLoggedIn) {
      axios
        .post(
          baseURLAddDiscount,
          {},
          {
            params: {
              code: discountText,
            },
            headers: authHeader(),
          }
        )
        .then((response) => {
          setProduct2(response.data["CartDetails"]);
          setDiscount("");
          setDiscountErr("");

          setCart(response.data ? response.data : {});
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                checkDiscount();
              } else {
              }
            });
          } else {
            setDiscountErr(err.response.data?.toString());
          }
        });
    } else {
      let postObj = {
        CartId: 0,
        UserId: 0,
        TotalAmount: 0,
        InstallAmount: 0,
        TransportationAmount: 0,
        TotalDiscount: 0,
        PayableAmount: 0,
        CartDetails: [],
        DiscountCodes: [...discounts],
      };
      if (localStorage.getItem("cart") !== null) {
        let cartObj = JSON.parse(localStorage.getItem("cart"));
        console.log(`cartObj`, cartObj);
        let draperies = cartObj["drapery"] || [];

        if (draperies.length) {
          let promiseArr = [];
          let cartIndex = 0;

          // Process items while preserving original order
          let orderedItems = [...draperies];

          orderedItems.forEach((item, index) => {
            promiseArr.push(
              new Promise((resolve, reject) => {
                if (item.FabricId || item.FabricId2) {
                  postObj["CartDetails"][cartIndex] = {
                    CartDetailId: cartIndex,
                    CartId: 0,
                    TypeId: 6403, // Drapery Type ID
                    Discount: 0,
                    Count: item["Count"],
                    ProductId: null,
                    ProductName: null,
                    ProductEnName: null,
                    ProductGroupId: null,
                    ProductDesignCode: null,
                    SewingOrderId: cartIndex,
                    PhotoUrl: null,
                    ProductDesignEnName: null,
                    ProductDesignName: null,
                    ProductColorEnName: null,
                    ProductColorName: null,
                    ProductColorId: null,
                    UnitPrice: item["Price"],
                    Amount: item["Price"] * item["Count"],
                    PayableAmount: item["Price"] * item["Count"],
                    SewingOrder: {
                      SewingOrderId: cartIndex,
                      IsCompleted: true,
                      ...item,
                    },
                  };
                  postObj["TotalAmount"] += item["Price"] * item["Count"];
                  if (item["ZipCode"] && item["ZipCode"] !== "") {
                    postObj["InstallAmount"] += (item["InstallAmount"] || 0) * (item["Count"] || 1);
                    if (postObj["InstallAmount"] === 0) {
                      postObj["TransportationAmount"] = item["TransportationAmount"] || 0;
                    }
                  }
                } else if (item.ProductId) {
                  postObj["CartDetails"][cartIndex] = {
                    CartDetailId: cartIndex,
                    CartId: 0,
                    TypeId: 6401, // Product Type ID
                    Discount: 0,
                    Count: item["Count"],
                    ProductId: item["ProductId"],
                    ProductName: item["ProductName"],
                    ProductEnName: item["ProductEnName"],
                    ProductGroupId: item["ProductGroupId"] || null,
                    ProductDesignCode: item["ProductDesignCode"] || null,
                    SewingOrderId: null,
                    PhotoUrl: item["PhotoUrl"] || null,
                    ProductDesignEnName: item["ProductDesignEnName"] || null,
                    ProductDesignName: item["ProductDesignName"] || null,
                    ProductColorEnName: item["ProductColorEnName"] || null,
                    ProductColorName: item["ProductColorName"] || null,
                    ProductColorId: item["ProductColorId"] || null,
                    UnitPrice: item["Price"],
                    Amount: item["Price"] * item["Count"],
                    PayableAmount: item["Price"] * item["Count"],
                  };
                  postObj["TotalAmount"] += item["Price"] * item["Count"];
                }
                cartIndex++;
                resolve();
              })
            );
          });
          Promise.all(promiseArr).then(() => {
            postObj["PayableAmount"] =
              postObj["TotalAmount"] + postObj["InstallAmount"] + postObj["TransportationAmount"];
            console.log(`postObj`, postObj);
            axios
              .post(baseURLAddDiscountGuest, postObj, {
                params: {
                  code: discountText,
                },
              })
              .then((response) => {
                console.log(`response.data`, response.data["CartDetails"]);
                setProductGuest(response.data["CartDetails"]);
                setTotalSaving(response.data["TotalDiscount"]);
                setDiscounts(response.data["DiscountCodes"]);
                setPriceTotal(response.data);
                setDiscount("");
                setDiscountErr("");
                const lcString = localStorage.getItem("cart");
                const lc = JSON.parse(lcString);

                if (localStorage.getItem("cart") !== null) {
                  let cartObj = JSON.parse(localStorage.getItem("cart"));
                  console.log(`cartObj`, cartObj);
                  let promiseArr = [];
                  response.data["CartDetails"].forEach((tempObj, index) => {
                    promiseArr.push(
                      new Promise((resolve, reject) => {
                        console.log(`tempObj `, tempObj);
                        console.log(`tempObj["TypeId"] `, tempObj["TypeId"]);
                        let cartType = tempObj["TypeId"] === 6403 ? "drapery" : "drapery";
                        console.log(`cartType`, cartType);
                        let temp = cartObj[cartType];
                        console.log(`temp`, temp);
                        console.log(`temp`, temp[1]["DiscountedPrice"]);
                        console.log(`response.data["CartDetails"]`, response.data["CartDetails"]);
                        temp[tempObj["CartDetailId"]]["Discount"] = tempObj["Discount"];
                        temp[tempObj["CartDetailId"]]["PreorderText"]["Discount"] =
                          tempObj["Discount"];
                        resolve();
                      })
                    );
                  });

                  Promise.all(promiseArr).then(() => {
                    localStorage.setItem("cart", JSON.stringify(cartObj));
                    setCartChanged(cartChanged + 1);
                  });
                } else {
                  setCartChanged(cartChanged + 1);
                }

                lc.discountList = response.data["DiscountCodes"] || [];
                localStorage.setItem("cart", JSON.stringify(lc));
                // localStorage.setItem(
                //   "discount",
                //   JSON.stringify(response.data["DiscountCodes"])
                // );
              })
              .catch((err) => {
                setDiscountErr(err.response.data?.toString());
              });
          });
        }
      }
    }
  }

  function removeDiscount(discountText) {
    if (isLoggedIn) {
      axios
        .delete(baseURLDeleteDiscount, {
          params: {
            code: discountText,
          },
          headers: authHeader(),
        })
        .then((response) => {
          setCartChanged(cartChanged + 1);
          setProduct2(response.data.CartDetails);
          setCart(response.data ? response.data : {});
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                removeDiscount(discountText);
              } else {
              }
            });
          } else {
          }
        });
    } else {
      let postObj = {
        CartId: 0,
        UserId: 0,
        TotalAmount: 0,
        InstallAmount: 0,
        TransportationAmount: 0,
        TotalDiscount: 0,
        PayableAmount: 0,
        CartDetails: [],
        DiscountCodes: [...discounts],
      };
      if (localStorage.getItem("cart") !== null) {
        let cartObj = JSON.parse(localStorage.getItem("cart"));
        console.log(`cartObj`, cartObj);
        let draperies = cartObj["drapery"] || [];

        if (draperies.length) {
          let promiseArr = [];
          let cartIndex = 0;

          let orderedItems = [...draperies];

          orderedItems.forEach((item, index) => {
            promiseArr.push(
              new Promise((resolve, reject) => {
                if (item.FabricId || item.FabricId2) {
                  postObj["CartDetails"][cartIndex] = {
                    CartDetailId: cartIndex,
                    CartId: 0,
                    TypeId: 6403, // Drapery Type ID
                    Discount: 0,
                    Count: item["Count"],
                    ProductId: null,
                    ProductName: null,
                    ProductEnName: null,
                    ProductGroupId: null,
                    ProductDesignCode: null,
                    SewingOrderId: cartIndex,
                    PhotoUrl: null,
                    ProductDesignEnName: null,
                    ProductDesignName: null,
                    ProductColorEnName: null,
                    ProductColorName: null,
                    ProductColorId: null,
                    UnitPrice: item["Price"],
                    Amount: item["Price"] * item["Count"],
                    PayableAmount: item["Price"] * item["Count"],
                    SewingOrder: {
                      SewingOrderId: cartIndex,
                      IsCompleted: true,
                      ...item,
                    },
                  };
                  postObj["TotalAmount"] += item["Price"] * item["Count"];
                  if (item["ZipCode"] && item["ZipCode"] !== "") {
                    postObj["InstallAmount"] += (item["InstallAmount"] || 0) * (item["Count"] || 1);
                    if (postObj["InstallAmount"] === 0) {
                      postObj["TransportationAmount"] = item["TransportationAmount"] || 0;
                    }
                  }
                } else if (item.ProductId) {
                  postObj["CartDetails"][cartIndex] = {
                    CartDetailId: cartIndex,
                    CartId: 0,
                    TypeId: 6401,
                    Discount: 0,
                    Count: item["Count"],
                    ProductId: item["ProductId"],
                    ProductName: item["ProductName"],
                    ProductEnName: item["ProductEnName"],
                    ProductGroupId: item["ProductGroupId"] || null,
                    ProductDesignCode: item["ProductDesignCode"] || null,
                    SewingOrderId: null,
                    PhotoUrl: item["PhotoUrl"] || null,
                    ProductDesignEnName: item["ProductDesignEnName"] || null,
                    ProductDesignName: item["ProductDesignName"] || null,
                    ProductColorEnName: item["ProductColorEnName"] || null,
                    ProductColorName: item["ProductColorName"] || null,
                    ProductColorId: item["ProductColorId"] || null,
                    UnitPrice: item["Price"],
                    Amount: item["Price"] * item["Count"],
                    PayableAmount: item["Price"] * item["Count"],
                  };
                  postObj["TotalAmount"] += item["Price"] * item["Count"];
                }
                cartIndex++;
                resolve();
              })
            );
          });
          Promise.all(promiseArr).then(() => {
            postObj["PayableAmount"] =
              postObj["TotalAmount"] + postObj["InstallAmount"] + postObj["TransportationAmount"];
           
            axios
              .delete(baseURLDeleteDiscount2, {
                data: postObj,
                params: {
                  code: discountText,
                },
              })
              .then((response) => {
                console.log(`response.data`, response.data);
                setProductGuest(response.data["CartDetails"]);
                setTotalSaving(response.data["TotalDiscount"]);
                setDiscounts(response.data["DiscountCodes"]);
                setPriceTotal(response.data);
                setDiscount("");
                setDiscountErr("");

                if (localStorage.getItem("cart") !== null) {
                  let cartObj = JSON.parse(localStorage.getItem("cart"));

                  let promiseArr = [];
                  response.data["CartDetails"].forEach((tempObj, index) => {
                    promiseArr.push(
                      new Promise((resolve, reject) => {
                        let cartType = tempObj["TypeId"] === 6403 ? "drapery" : "product";
                        let temp = cartObj[cartType];

                        temp[tempObj["CartDetailId"]]["Discount"] = tempObj["Discount"];
                        temp[tempObj["CartDetailId"]]["PreorderText"]["Discount"] =
                          tempObj["Discount"];
                        resolve();
                      })
                    );
                  });

                  Promise.all(promiseArr).then(() => {
                    localStorage.setItem("cart", JSON.stringify(cartObj));
                    setCartChanged(cartChanged + 1);
                  });
                } else {
                  setCartChanged(cartChanged + 1);
                }

                const lcString = localStorage.getItem("cart");
                const lc = JSON.parse(lcString);
                let result = lc.discountList;

                result = result.filter((item) => item.Code !== discountText);

                lc.discountList = result;
                localStorage.setItem("cart", JSON.stringify(lc));
              })
              .catch((err) => {
                setDiscountErr(err.response.data?.toString());
              });
          });
        }
      }
    }
  }

  function normalizeShippingMethods(data) {
    if (!data) return [];
    const list = Array.isArray(data)
      ? data
      : data.ShippingMethods || data.shippingMethods || data.Data || [];
    return Array.isArray(list) ? list : [];
  }

  function getShippingMethodLabel(method) {
    if (method == null) return "";
    if (typeof method === "string" || typeof method === "number") return String(method);
    if (pageLanguage === "fa") {
      return (
        method.MethodName ||
        method.NameFa ||
        method.name_fa ||
        method.Name ||
        method.name ||
        method.MethodEnName ||
        method.TitleFa ||
        method.Title ||
        method.label ||
        ""
      );
    }
    return (
      method.MethodEnName ||
      method.NameEn ||
      method.Name ||
      method.name ||
      method.MethodName ||
      method.TitleEn ||
      method.Title ||
      method.label ||
      ""
    );
  }

  function getShippingMethodDeliveryTime(method) {
    if (method == null) return "";
    if (pageLanguage === "fa") {
      return (
        method.EstimatedDeliveryTime ||
        method.DeliveryTimeFa ||
        method.delivery_time_fa ||
        method.DeliveryTime ||
        method.delivery_time ||
        method.EstimatedDeliveryTimeEn ||
        ""
      );
    }
    return (
      method.EstimatedDeliveryTimeEn ||
      method.DeliveryTime ||
      method.delivery_time ||
      method.EstimatedDeliveryTime ||
      method.DeliveryTimeFa ||
      method.delivery_time_fa ||
      ""
    );
  }

  function getShippingMethodKey(method, index) {
    return method?.id ?? method?.ShippingMethodId ?? index;
  }

  function getShippingMethodPriceValue(method) {
    const price = method?.Price ?? method?.price;
    if (price == null || price === "") return 0;
    return Number(price) || 0;
  }

  function formatShippingMethodPrice(method) {
    const price = getShippingMethodPriceValue(method);
    if (price === 0) return "FREE";
    return GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile);
  }

  function getSelectedShippingMethod() {
    if (shippingMethods.length === 0) return null;

    if (selectedShippingMethodKey != null) {
      const selected = shippingMethods.find(
        (method, index) => getShippingMethodKey(method, index) === selectedShippingMethodKey
      );
      if (selected) return selected;
    }

    return shippingMethods.find((method) => getShippingMethodLabel(method)) || null;
  }

  function getSelectedShippingMethodId() {
    const method = getSelectedShippingMethod();
    if (!method) return null;

    const methodId = method.ShippingMethodId ?? method.id;
    if (methodId == null || methodId === "") return null;
    return Number(methodId);
  }

  function getEffectiveSelectedShippingMethodKey() {
    if (selectedShippingMethodKey != null) {
      const stillValid = shippingMethods.some(
        (method, index) => getShippingMethodKey(method, index) === selectedShippingMethodKey
      );
      if (stillValid) return selectedShippingMethodKey;
    }

    const firstIndex = shippingMethods.findIndex((method) => getShippingMethodLabel(method));
    if (firstIndex === -1) return null;
    return getShippingMethodKey(shippingMethods[firstIndex], firstIndex);
  }

  function handleShippingMethodSelect(method, methodKey) {
    setSelectedShippingMethodKey(methodKey);
    setShippingPrice(getShippingMethodPriceValue(method));
    setNoShipping(false);
    // setTimeout(() => {
    //   setShippingMethodExpanded(false);
    // }, 300);

  }

  function getZipCodeDigits(value) {
    return String(value || "").replace(/\D/g, "");
  }

  function getLoggedInShippingAddressId() {
    if (!isLoggedIn || !userAddress.length) return null;

    if (selectedAddress.length) {
      if (selectedAddress[0].value === -1) return null;
      return selectedAddress[0].value;
    }

    const defaultIndex = userAddress.findIndex((opt) => opt["IsDefault"] === true);
    const index = defaultIndex === -1 ? 0 : defaultIndex;
    return userAddress[index]?.CustomerAddressId ?? null;
  }

  function applyShippingMethodsResponse(methods) {
    setSelectedShippingMethodKey(null);
    setShippingMethods(methods);
    if (methods.length > 0) {
      setShippingMethodExpanded(true);
    }
  }

  function fetchLoggedInShippingMethodsByAddressId(addressId) {
    if (!addressId || addressId === -1) return;

    axios
      .get(baseURLGetShippingMethods, {
        headers: authHeader(),
        params: { addressId: Number(addressId) },
      })
      .then((response) => {
        applyShippingMethodsResponse(normalizeShippingMethods(response.data));
      })
      .catch(() => {
        setShippingMethods([]);
      });
  }

  function fetchGuestShippingMethodsByZipCode(zipCode) {
    const zipDigits = getZipCodeDigits(zipCode);
    if (zipDigits.length !== 10) return;

    axios
      .get(baseURLGetShippingMethods, {
        params: { addressId: Number(zipDigits) },
      })
      .then((response) => {
        applyShippingMethodsResponse(normalizeShippingMethods(response.data));
      })
      .catch(() => {
        setShippingMethods([]);
      });
  }

  function setAddress(num, refIndex, value) {
    if (num === 1) {
      let temp = JSON.parse(JSON.stringify(address1));
      temp[refIndex] = value;
      setAddress1(temp);
    } else {
      let temp = JSON.parse(JSON.stringify(address2));
      temp[refIndex] = value;
      setAddress2(temp);
    }
  }

  function logoutUser() {
    if (localStorage.getItem("user") !== null) {
      localStorage.removeItem("user");
    }
    setUserAddress([]);
    store.dispatch({
       type: LOGOUT,
    });
  }


  function getUserAddress() {
    axios
      .get(baseURLGetAddress, {
        headers: authHeader(),
      })
      .then((response) => {
        setUserAddress(response.data);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getUserAddress();
            } else {
              navigate("/" + pageLanguage);
            }
          });
        }
      });
  }

  function deleteCheckoutAddress(addressId) {
    axios
      .delete(baseURLDeleteAddress, {
        params: { id: addressId },
        headers: authHeader(),
      })
      .then(() => {
        setAddressMenuOpenId(null);
        setShowDeleteAddressModal(false);
        setDeleteAddressId(null);
        getUserAddress();
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              deleteCheckoutAddress(addressId);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        }
      });
  }

  function renderUserAddress() {
    let arrayObj = userAddress.map((item) => {
      return {
        value: item["CustomerAddressId"],
        label: `${t("Iran")} ${pageLanguage === "fa" ? item["CityName"] : item["CityEnName"]} ${
          item["Address"]
        } ${item["Address2"]} ${item["ZipCode"]}`,
      };
    });

    let finalArray = [
      {
        value: -1,
        label: t("create_new_address"),
      },
    ];
    setUserAddressRender([...finalArray, ...arrayObj]);
    setHasAddress(true);

    let tempIndex = userAddress.findIndex((opt) => opt["IsDefault"] === true);
    if (tempIndex === -1) {
      tempIndex = 0;
    }

    const defaultAddressOption = arrayObj[tempIndex];
    if (defaultAddressOption) {
      setSelectedAddress([defaultAddressOption]);
    }

    if (localStorage.getItem("user") !== null && isLoggedIn) {
      let tempObj = JSON.parse(localStorage.getItem("user"));

      setAddress1({
        id: "",
        Name: `${jwt(tempObj["access_token"])["FirstName"]}`,
        Last: `${jwt(tempObj["access_token"])["LastName"]}`,
        Address1: userAddress[tempIndex]["Address"],
        Address2: userAddress[tempIndex]["Address2"],
        State: userAddress[tempIndex]["StateId"],
        City: userAddress[tempIndex]["CityId"],
        ZipCode: userAddress[tempIndex]["ZipCode"],
        PhoneNumber: userAddress[tempIndex]["Mobile"],
      });

      setTempCityId(userAddress[tempIndex]["CityId"]);
      setTimeout(() => {
        setSelectedState(
          states.find((opt) => opt.value === userAddress[tempIndex]["ZoneNo"])
            ? [states.find((opt) => opt.value === userAddress[tempIndex]["ZoneNo"])]
            : []
        );
        if (states.find((opt) => opt.value === userAddress[tempIndex]["ZoneNo"])) {
        } else {
          setSelectedCity([]);
          setCities([]);
        }
      }, 200);
    }
  }

  function getCities(pageLang, stateId) {
    if (stateId === undefined) {
      axios
        .get(baseURLGetStates, {
          headers: authHeader(),
        })
        .then((response) => {
          let arrayObj = response.data.map((item) => {
            return {
              value: item["CityId"],
              label: pageLang === "fa" ? item["CityName"] : item["CityEnName"],
            };
          });
          if (selectedState.length) {
            setTempCity(selectedCity);
            setSelectedState([arrayObj.find((opt) => opt.value === selectedState[0].value)]);
          }
          setStates(arrayObj);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axios
        .get(baseURLGetCities + stateId, {
          headers: authHeader(),
        })
        .then((response) => {
          let arrayObj = response.data.map((item) => {
            return {
              value: item["CityId"],
              label: pageLang === "fa" ? item["CityName"] : item["CityEnName"],
            };
          });
          if (tempCityId) {
            let tempValue = JSON.parse(JSON.stringify(tempCityId));
            setTempCityId(undefined);
            setTempCity([]);
            setTimeout(() => {
              // console.log(tempValue);
              setSelectedCity(
                arrayObj.find((opt) => opt.value === tempValue)
                  ? [arrayObj.find((opt) => opt.value === tempValue)]
                  : []
              );
            }, 50);
          } else if (tempCity.length) {
            let tempValue = tempCity[0].value;
            setTempCity([]);
            setTimeout(() => {
              setSelectedCity([arrayObj.find((opt) => opt.value === tempValue)]);
            }, 50);
          } else {
            setSelectedCity([]);
            setAddress(1, "City", "");
          }
          // console.log(arrayObj);
          setCities(arrayObj);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function findStateOptionForAddress(addr) {
    if (!states.length || !addr) {
      return null;
    }
    const ids = [addr["ZoneNo"], addr["StateId"]].filter(
      (id) => id !== undefined && id !== null && id !== ""
    );
    for (const id of ids) {
      const found = states.find((opt) => String(opt.value) === String(id));
      if (found) {
        return found;
      }
    }
    return null;
  }

  function getEditCities(pageLang, stateId, cityIdToSelect) {
    if (!stateId) {
      setEditCities([]);
      setEditSelectedCity([]);
      return;
    }

    axios
      .get(baseURLGetCities + stateId, {
        headers: authHeader(),
      })
      .then((response) => {
        const arrayObj = response.data.map((item) => ({
          value: item["CityId"],
          label: pageLang === "fa" ? item["CityName"] : item["CityEnName"],
        }));
        setEditCities(arrayObj);
        if (cityIdToSelect !== undefined && cityIdToSelect !== null && cityIdToSelect !== "") {
          const matchedCity = arrayObj.find(
            (opt) => String(opt.value) === String(cityIdToSelect)
          );
          setEditSelectedCity((prev) => {
            if (matchedCity) {
              return [matchedCity];
            }
            if (
              prev.length &&
              String(prev[0].value) === String(cityIdToSelect)
            ) {
              return prev;
            }
            return [];
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function clearAddressFields() {
    setAddress1({
      id: "",
      Name: "",
      Last: "",
      Address1: "",
      Address2: "",
      State: "1",
      City: "1",
      ZipCode: "",
      PhoneNumber: "",
    });
    setSelectedCity([]);
    setSelectedState([]);
  }

  function setAllAddress(tempValue) {
    let tempIndex = userAddress.findIndex((opt) => opt["CustomerAddressId"] === tempValue);
    if (tempIndex === -1) {
      clearAddressFields();
    }
    if (localStorage.getItem("user") !== null && isLoggedIn) {
      let tempObj = JSON.parse(localStorage.getItem("user"));

      setAddress1({
        id: "",
        Name: userAddress[tempIndex]["FirstName"],
        Last: userAddress[tempIndex]["LastName"],
        Address1: userAddress[tempIndex]["Address"],
        Address2: userAddress[tempIndex]["Address2"],
        State: userAddress[tempIndex]["StateId"],
        City: userAddress[tempIndex]["CityId"],
        ZipCode: userAddress[tempIndex]["ZipCode"],
        PhoneNumber: userAddress[tempIndex]["Mobile"],
      });

      setTempCityId(userAddress[tempIndex]["CityId"]);
      setTimeout(() => {
        setSelectedState(
          states.find((opt) => opt.value === userAddress[tempIndex]["ZoneNo"])
            ? [states.find((opt) => opt.value === userAddress[tempIndex]["ZoneNo"])]
            : []
        );
        if (states.find((opt) => opt.value === userAddress[tempIndex]["ZoneNo"])) {
        } else {
          setSelectedCity([]);
          setCities([]);
        }
      }, 300);
    }
  }

  function ContextAwareToggleViewDetails({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <button
        className="basket_item_title_dropdown_btn"
        aria-expanded={`${isCurrentEventKey}`}
        type="button"
        onClick={decoratedOnClick}
      >
        <h4 className="dk_curtain_preview_item_details">
          {isCurrentEventKey ? textOnShow : textOnHide}
        </h4>
      </button>
    );
  }

  useEffect(() => {
    if (userAddress.length) {
      renderUserAddress();
    } else {
      // setHasAddress(false);
    }
  }, [userAddress]);

  useEffect(() => {
    if (addressMenuOpenId === null) {
      return undefined;
    }

    const closeMenu = () => setAddressMenuOpenId(null);
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, [addressMenuOpenId]);

  useEffect(() => {
    if (!isLoggedIn) {
      lastLoggedInShippingAddressIdRef.current = "";
      return;
    }

    if (!userAddress.length) {
      lastLoggedInShippingAddressIdRef.current = "";
      setShippingMethods([]);
      setSelectedShippingMethodKey(null);
      setShippingPrice(0);
      return;
    }

    const addressId = getLoggedInShippingAddressId();
    if (!addressId) {
      lastLoggedInShippingAddressIdRef.current = "";
      setShippingMethods([]);
      setSelectedShippingMethodKey(null);
      setShippingPrice(0);
      return;
    }

    const addressIdKey = String(addressId);
    if (lastLoggedInShippingAddressIdRef.current === addressIdKey) return;
    lastLoggedInShippingAddressIdRef.current = addressIdKey;
    fetchLoggedInShippingMethodsByAddressId(addressId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddress, userAddress, isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) {
      lastGuestShippingZipRef.current = "";
      return;
    }

    const zipDigits = getZipCodeDigits(address1["ZipCode"]);
    if (zipDigits.length !== 10) {
      if (lastGuestShippingZipRef.current) {
        lastGuestShippingZipRef.current = "";
        setShippingMethods([]);
        setSelectedShippingMethodKey(null);
        setShippingPrice(0);
      }
      return;
    }

    if (lastGuestShippingZipRef.current === zipDigits) return;
    lastGuestShippingZipRef.current = zipDigits;
    fetchGuestShippingMethodsByZipCode(zipDigits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address1["ZipCode"], isLoggedIn]);

  useEffect(() => {
    if (shippingMethods.length === 0) {
      setSelectedShippingMethodKey(null);
      setShippingPrice(0);
      return;
    }

    const selectedStillValid = shippingMethods.some(
      (method, index) => getShippingMethodKey(method, index) === selectedShippingMethodKey
    );

    if (selectedStillValid) return;

    const firstIndex = shippingMethods.findIndex((method) => getShippingMethodLabel(method));
    if (firstIndex === -1) return;

    const firstMethod = shippingMethods[firstIndex];
    handleShippingMethodSelect(firstMethod, getShippingMethodKey(firstMethod, firstIndex));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingMethods]);

  useEffect(() => {
    if (isLoggedIn) {
      axios
        .get(baseURLGetCart, {
          headers: authHeader(),
        })
        .then((response) => {
          setProduct2(response.data.CartDetails);
          //  setProducts(response.data.CartDetails)
          setCart(response.data ? response.data : {});
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                setCartChanged(cartChanged + 1);
              } else {
              }
            });
          }
        });
    } else {
      if (localStorage.getItem("cart") !== null) {
        setCart(JSON.parse(localStorage.getItem("cart")));
      } else {
        setCart({});
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      setCartChanged(cartChanged + 1);
    }
  }, [isLoggedIn, multipleAdded]);

  useEffect(() => {
    if (Object.keys(cart).length !== 0) {
      if (isLoggedIn) {
        if (swatchOnly === undefined) {
          let draperies = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6403;
          });

          let swatches = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6402;
          });
          setSubTotalPrice(cart["TotalAmount"]);
          const draperiesFromCart = (cart["CartDetails"] || []).filter((c) => c.TypeId === 6403);
          const calculatedInstall = draperiesFromCart.reduce((sum, c) => {
            const install = c.InstallAmount ?? c.SewingOrder?.PreorderText?.InstallAmount ?? 0;
            const qty = c.Count ?? c.SewingOrder?.PreorderText?.WindowCount ?? 1;
            return sum + install * qty;
          }, 0);
          const installToUse =
            calculatedInstall > 0 ? calculatedInstall : cart["InstallAmount"] || 0;
          setInstallPrice(installToUse);
          setTransportPrice(cart["TransportationAmount"]);
          setTotalPrice((cart["PayableAmount"] || 0) - (cart["InstallAmount"] || 0) + installToUse);
          setTotalSaving(cart["TotalDiscount"]);
          setDrapery(draperies);
          setSwatches(swatches);
          setDiscounts(cart["DiscountCodes"]);
        } else if (swatchOnly && swatchOnly === "Swatches") {
          let swatches = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6402;
          });
          setSwatches(swatches);
          setDiscounts(cart["DiscountCodes"]);
        } else {
          navigate("/" + pageLanguage);
        }
      } else {
        if (cart["drapery"] === undefined || cart["drapery"] === []) {
          setDrapery([]);
        } else {
          setDrapery(cart["drapery"]);
        }
       
        if (cart["swatches"] === undefined || cart["swatches"] === []) {
          setSwatches([]);
        } else {
          setSwatches(cart["swatches"]);
        }
      }
    } else {
      setDrapery([]);
      setSwatches([]);
    }
  }, [cart]);

  useEffect(() => {
    let projectData = JSON.parse(JSON.stringify(UserProjects));
    if (isLoggedIn) {
      let tempDrapery = JSON.parse(JSON.stringify(drapery));
      let temp = [];
      let tempNoShip = true;
      let promiseArr = [];
      tempDrapery
        .sort(function(a, b) {
          return b["CartDetailId"] - a["CartDetailId"] || b["SewingOrderId"] - a["SewingOrderId"];
        })
        .forEach((obj1, i) => {
          promiseArr[i] = new Promise((resolve, reject) => {
            let obj = obj1["SewingOrder"]["PreorderText"] || {};
            let SewingModelId = obj["SewingModelId"];
            let userProjects = projectData[obj["SewingModelId"]]
              ? projectData[obj["SewingModelId"]]["data"]
              : [];
            let desc = [];
            let temp1 = [];
            let temp2 = [];
            let temp3 = [];
            let temp4 = [];
            let temp5 = [];
            let defaultModelNameFa = obj["ModelNameFa"];
            let defaultModelName = obj["ModelNameEn"];
            let roomNameFa = obj["RoomNameFa"];
            let roomName = obj["RoomNameEn"];
            let WindowName = obj["WindowName"] === undefined ? "" : obj["WindowName"];
            let moreInfoInput = obj["moreInfoInput"] === undefined ? "" : obj["moreInfoInput"];
            let photoUrl = obj["PhotoUrl"];
            let hasDiscount = obj1["Discount"] > 0;
            let zipcode = obj["ZipCode"];
            obj["Price"] = obj1["PayableAmount"];

            if (tempNoShip) {
              tempNoShip = zipcode && zipcode !== "";
            }
            let promiseArr0 = [];
            if (SewingModelId === "0099") {
              promiseArr0[0] = new Promise((resolve, reject) => {
                GetUserProjectData(obj1["SewingOrder"], true)
                  .then((cartValues) => {
                    let promiseArr4 = [];
                    if (cartValues["Accessories"] !== undefined) {
                      cartValues["Accessories"].forEach((obj, index) => {
                        if (
                          obj["DesignNameFa"] !== undefined &&
                          obj["DesignNameEn"] !== undefined
                        ) {
                          promiseArr4[index] = new Promise((resolve, reject) => {
                            if (obj["DesignNameFa"] && obj["DesignNameEn"]) {
                              temp4[index] = (
                                <li className="cart_agree_item" key={"acc" + index}>
                                  <h1 className="cart_agree_item_title">
                                    {pageLanguage === "fa"
                                      ? obj["DesignNameFa"]
                                      : obj["DesignNameEn"]}
                                  </h1>
                                  <h2 className="cart_agree_item_desc">
                                    {t("agree_Qty")}
                                    {NumToFa(obj["Qty"], pageLanguage)}
                                  </h2>
                                </li>
                              );
                            }
                            resolve();
                          });
                        }
                      });
                    }

                    let promiseArr3 = [];
                    Object.keys(cartValues).forEach((key, index) => {
                      promiseArr3[index] = new Promise((resolve, reject) => {
                        let tempObj = userProjects.find((obj) => obj["cart"] === key);
                        if (tempObj === undefined || cartValues[key] === undefined) {
                          // window.location.reload();

                          resolve();
                        } else {
                          if (
                            (key === "PanelTypeOption" &&
                              cartValues["PanelTypeOption"] === "Customize Style Per Curtain") ||
                            (key === "Hardware" &&
                              cartValues["Hardware"] === "I Want To Customize Hardware Per Curtain")
                          ) {
                            resolve();
                          } else if (
                            tempObj["title"] !== "" &&
                            tempObj["lang"].indexOf(pageLanguage) > -1
                          ) {
                            let objLabel = "";
                            if (
                              key === "ControlType" &&
                              cartValues["ControlType"] === "Motorized"
                            ) {
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${t(cartValues[key]?.toString())} / ${t(
                                        cartValues["MotorType"]?.toString()
                                      )}`
                                    )?.toString()
                                  : `${t(cartValues[key]?.toString())} / ${t(
                                      cartValues["MotorType"]?.toString()
                                    )}`;
                            } else if (
                              key === "DraperyHardware" &&
                              cartValues["DraperyHardware"] !== "None"
                            ) {
                              objLabel =
                                t(cartValues[key]?.toString()) +
                                " / " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailDesignFaA"]
                                  : cartValues["RailDesignEnA"]) +
                                " \n " +
                                (pageLanguage === "fa"
                                  ? cartValues["RailColorFaA"]
                                  : cartValues["RailColorEnA"]) +
                                " / " +
                                t(cartValues["BatonOptionA"]);
                            } else if (
                              key === "SheerHardware" &&
                              cartValues["SheerHardware"] !== "None"
                            ) {
                              if (cartValues["RailDesignEnB"] === "Motorized Track") {
                                objLabel =
                                  t(cartValues[key]?.toString()) +
                                  " / " +
                                  (pageLanguage === "fa"
                                    ? cartValues["RailDesignFaB"]
                                    : cartValues["RailDesignEnB"]);
                              } else {
                                objLabel =
                                  t(cartValues[key]?.toString()) +
                                  " / " +
                                  (pageLanguage === "fa"
                                    ? cartValues["RailDesignFaB"]
                                    : cartValues["RailDesignEnB"]) +
                                  " \n " +
                                  (pageLanguage === "fa"
                                    ? cartValues["RailColorFaB"]
                                    : cartValues["RailColorEnB"]) +
                                  " / " +
                                  (cartValues["BatonOptionB"]
                                    ? t(cartValues["BatonOptionB"])
                                    : t(cartValues["ControlPositionB"]));
                              }
                            } else if (
                              key === "PrivacyLayerHardware" &&
                              cartValues["PrivacyLayerHardware"] !== "None"
                            ) {
                              if (cartValues["RailDesignEnC"] === "Motorized Track") {
                                objLabel =
                                  t(cartValues[key]?.toString()) +
                                  " / " +
                                  (pageLanguage === "fa"
                                    ? cartValues["RailDesignFaC"]
                                    : cartValues["RailDesignEnC"]);
                              } else {
                                objLabel =
                                  t(cartValues[key]?.toString()) +
                                  " / " +
                                  (pageLanguage === "fa"
                                    ? cartValues["RailDesignFaC"]
                                    : cartValues["RailDesignEnC"]) +
                                  " \n " +
                                  (pageLanguage === "fa"
                                    ? cartValues["RailColorFaC"]
                                    : cartValues["RailColorEnC"]) +
                                  " / " +
                                  (cartValues["BatonOptionC"]
                                    ? t(cartValues["BatonOptionC"])
                                    : t(cartValues["ControlPositionC"]));
                              }
                            } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                              objLabel =
                                t("agree_Qty") +
                                NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                            } else if (key === "HandCurtainEn2" || key === "HandCurtainFa2") {
                              objLabel =
                                t("agree_Qty") +
                                NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                            } else if (tempObj["titleValue"] === null || true) {
                              if (tempObj["titlePostfix"] === "") {
                                objLabel =
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(
                                        `${t(cartValues[key]?.toString())}`
                                      )?.toString()
                                    : t(cartValues[key]?.toString());
                              } else {
                                objLabel =
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(
                                        `${cartValues[key]}`
                                      )?.toString() + t(tempObj["titlePostfix"])
                                    : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                              }
                            } else {
                              if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                                if (tempObj["titlePostfix"] === "") {
                                  objLabel = t(cartValues[key].toString());
                                } else {
                                  objLabel =
                                    pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(
                                          `${cartValues[key]}`
                                        ).toString() + t(tempObj["titlePostfix"])
                                      : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                                }
                              } else {
                                objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                              }
                            }
                            if (tempObj["fabric"] === undefined) {
                              temp5[tempObj["order"]] = (
                                <li className="cart_agree_item" key={key}>
                                  <h1 className="cart_agree_item_title">
                                    {t(tempObj["title"])}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                </li>
                              );
                              resolve();
                            } else if (tempObj["fabric"] === 1) {
                              temp1[tempObj["order"]] = (
                                <li className="cart_agree_item" key={key}>
                                  <h1 className="cart_agree_item_title">
                                    {t(tempObj["title"])}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                </li>
                              );
                              resolve();
                            } else if (tempObj["fabric"] === 2) {
                              temp2[tempObj["order"]] = (
                                <li className="cart_agree_item" key={key}>
                                  <h1 className="cart_agree_item_title">
                                    {t(tempObj["title"])}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                </li>
                              );
                              resolve();
                            } else if (tempObj["fabric"] === 3) {
                              temp3[tempObj["order"]] = (
                                <li className="cart_agree_item" key={key}>
                                  <h1 className="cart_agree_item_title">
                                    {t(tempObj["title"])}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                </li>
                              );
                              resolve();
                            } else {
                              resolve();
                            }
                          } else {
                            resolve();
                          }
                        }
                      });
                    });
                    Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                      desc[40] = (
                        <>
                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                            <h1 className="cart_agree_item_fabrics_sorted_title">
                              {t("General Details")}
                            </h1>
                            <ul>{temp5}</ul>
                          </li>
                          {cartValues["FabricId"] && (
                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                              <h1 className="cart_agree_item_fabrics_sorted_title">
                                {t("Drapery")}
                              </h1>
                              <ul>
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title">
                                    {t("Fabric & Color")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc">
                                    {pageLanguage === "fa"
                                      ? cartValues["FabricDesignFa"] +
                                        " / " +
                                        cartValues["FabricColorFa"]
                                      : CapitalizeAllWords(
                                          cartValues["FabricDesignEn"] +
                                            " / " +
                                            cartValues["FabricColorEn"]
                                        )}
                                  </h2>
                                </li>
                                {cartValues["BorderOrTrimId"] && cartValues["borderPosition"] && (
                                  <li className="cart_agree_item">
                                    <h1 className="cart_agree_item_title">
                                      {t("Decorative Border")}&nbsp;
                                    </h1>
                                    <h2 className="cart_agree_item_desc">
                                      {pageLanguage === "fa"
                                        ? cartValues["BorderOrTrimDesignFa"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorFa"] +
                                          " \n " +
                                          t(cartValues["borderPosition"])
                                        : CapitalizeAllWords(
                                            cartValues["BorderOrTrimDesignEn"] +
                                              " / " +
                                              cartValues["BorderOrTrimColorEn"] +
                                              " \n " +
                                              t(cartValues["borderPosition"])
                                          )}
                                    </h2>
                                  </li>
                                )}
                                {cartValues["BorderOrTrimId"] && !cartValues["borderPosition"] && (
                                  <li className="cart_agree_item">
                                    <h1 className="cart_agree_item_title">
                                      {t("Decorative Trim")}&nbsp;
                                    </h1>
                                    <h2 className="cart_agree_item_desc">
                                      {pageLanguage === "fa"
                                        ? cartValues["BorderOrTrimDesignFa"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorFa"]
                                        : CapitalizeAllWords(
                                            cartValues["BorderOrTrimDesignEn"] +
                                              " / " +
                                              cartValues["BorderOrTrimColorEn"]
                                          )}
                                    </h2>
                                  </li>
                                )}
                                {temp1}
                              </ul>
                            </li>
                          )}
                          {cartValues["FabricId2"] && (
                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                              <h1 className="cart_agree_item_fabrics_sorted_title">{t("Sheer")}</h1>
                              <ul>
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title">
                                    {t("Fabric & Color")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc">
                                    {pageLanguage === "fa"
                                      ? cartValues["FabricDesignFa2"] +
                                        " / " +
                                        cartValues["FabricColorFa2"]
                                      : CapitalizeAllWords(
                                          cartValues["FabricDesignEn2"] +
                                            " / " +
                                            cartValues["FabricColorEn2"]
                                        )}
                                  </h2>
                                </li>
                                {cartValues["BorderOrTrimId2"] && cartValues["borderPosition2"] && (
                                  <li className="cart_agree_item">
                                    <h1 className="cart_agree_item_title">
                                      {t("Decorative Border")}&nbsp;
                                    </h1>
                                    <h2 className="cart_agree_item_desc">
                                      {pageLanguage === "fa"
                                        ? cartValues["BorderOrTrimDesignFa2"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorFa2"] +
                                          " \n " +
                                          t(cartValues["borderPosition2"])
                                        : CapitalizeAllWords(
                                            cartValues["BorderOrTrimDesignEn2"] +
                                              " / " +
                                              cartValues["BorderOrTrimColorEn2"] +
                                              " \n " +
                                              t(cartValues["borderPosition2"])
                                          )}
                                    </h2>
                                  </li>
                                )}
                                {cartValues["BorderOrTrimId2"] && !cartValues["borderPosition2"] && (
                                  <li className="cart_agree_item">
                                    <h1 className="cart_agree_item_title">
                                      {t("Decorative Trim")}&nbsp;
                                    </h1>
                                    <h2 className="cart_agree_item_desc">
                                      {pageLanguage === "fa"
                                        ? cartValues["BorderOrTrimDesignFa2"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorFa2"]
                                        : CapitalizeAllWords(
                                            cartValues["BorderOrTrimDesignEn2"] +
                                              " / " +
                                              cartValues["BorderOrTrimColorEn2"]
                                          )}
                                    </h2>
                                  </li>
                                )}
                                {temp2}
                              </ul>
                            </li>
                          )}
                          {cartValues["PrivacyLayer"] && cartValues["PrivacyLayer"] !== "none" && (
                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                              <h1 className="cart_agree_item_fabrics_sorted_title">
                                {t("Privacy Layer")}
                              </h1>
                              <ul>
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title">
                                    {t("Fabric & Color")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc">
                                    {pageLanguage === "fa"
                                      ? cartValues["SheersDesignFa"] +
                                        " / " +
                                        cartValues["SheersColorFa"]
                                      : CapitalizeAllWords(
                                          cartValues["SheersDesignEn"] +
                                            " / " +
                                            cartValues["SheersColorEn"]
                                        )}
                                  </h2>
                                </li>
                                {temp3}
                              </ul>
                            </li>
                          )}
                          {!!temp4.length && (
                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                              <h1 className="cart_agree_item_fabrics_sorted_title">
                                {t("Accessories")}
                              </h1>
                              <ul>{temp4}</ul>
                            </li>
                          )}

                          {moreInfoInput !== "" && (
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">{t("Order Notes")}&nbsp;</h1>
                              <ShowMoreLineLimited moreInfoInput={moreInfoInput} lines={3} />
                            </li>
                          )}
                        </>
                      );
                      resolve();
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                    resolve();
                  });
              });
            } else {
              Object.keys(obj).forEach((key, i) => {
                promiseArr0[i] = new Promise((resolve, reject) => {
                  let tempObj = userProjects.find((obj) => obj["apiLabel"] === key);
                  if (tempObj === undefined || obj[key] === undefined) {
                    resolve();
                  } else {
                    if (tempObj["title"] !== "" && tempObj["lang"].indexOf(pageLanguage) > -1) {
                      let objLabel = "";
                      let apiValue =
                        obj[tempObj["apiLabel"]] === null
                          ? "null"
                          : obj[tempObj["apiLabel"]].toString();
                      if (
                        tempObj["apiLabel"] === "ControlType" &&
                        obj["ControlType"] === "Motorized"
                      ) {
                        objLabel =
                          pageLanguage === "fa"
                            ? NumberToPersianWord.convertEnToPe(
                                `${t(obj[key].toString())} / ${t(obj["MotorType"].toString())}`
                              ).toString()
                            : `${t(obj[key].toString())} / ${t(obj["MotorType"].toString())}`;
                      } else if (tempObj["titleValue"] === null) {
                        if (tempObj["titlePostfix"] === "") {
                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(
                                  `${t(apiValue.toString())}`
                                ).toString()
                              : t(apiValue.toString());
                        } else {
                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${apiValue}`).toString() +
                                t(tempObj["titlePostfix"])
                              : apiValue.toString() + t(tempObj["titlePostfix"]);
                        }
                      } else {
                        if (tempObj["titleValue"][apiValue.toString()] === null) {
                          if (tempObj["titlePostfix"] === "") {
                            objLabel = t(apiValue.toString());
                          } else {
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${apiValue}`).toString() +
                                  t(tempObj["titlePostfix"])
                                : apiValue.toString() + t(tempObj["titlePostfix"]);
                          }
                        } else {
                          objLabel = t(tempObj["titleValue"][apiValue.toString()]);
                        }
                      }
                      desc[tempObj["order"]] = (
                        <div className="basket_item_title_desc" key={key}>
                          <h3>{t(tempObj["title"])}&nbsp;</h3>
                          <h4>{objLabel}</h4>
                        </div>
                      );
                      resolve();
                    } else {
                      resolve();
                    }
                  }
                });
              });
            }
            Promise.all(promiseArr0).then(() => {
              if (obj["SewingModelId"] === "0326") {
                desc = [
                  <div className="basket_item_title_desc" key={"fabric/color"}>
                    <h3>{t("Fabric/Color")}&nbsp;</h3>
                    <h4>
                      {obj["SodFabrics"].map((item, i) => (
                        <div key={i} className="dk_curtain_preview_detail">
                          <h2>
                            {(pageLanguage === "en"
                              ? CapitalizeAllWords(item["FabricObj"]["DesignEnName"])
                              : item["FabricObj"]["DesignName"]
                            ).toString() +
                              " / " +
                              (pageLanguage === "en"
                                ? CapitalizeAllWords(item["FabricObj"]["ColorEnName"])
                                : item["FabricObj"]["ColorName"]
                              ).toString()}
                          </h2>
                          <h5>&nbsp;X</h5>
                          <h3>{NumToFa(item["Qty"], pageLanguage)}</h3>
                        </div>
                      ))}
                    </h4>
                  </div>,
                  ...desc,
                ];
              }
              temp[i] = (
                <li className="checkout_item_container" key={i}>
                  <div className="checkout_item_image_container">
                    <img src={imgUrl(photoUrl)} alt="" className="checkout_item_img" />
                    <p className="checkout_item_image_qty 2">
                      {pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(`${obj["WindowCount"]}`)
                        : obj["WindowCount"]}
                    </p>
                  </div>
                  <div
                    className={`checkout_item_desc_container  ${
                      !hasDiscount ? "checkout_item_desc_container_without_discount" : ""
                    }`}
                  >
                    <div className="checkout_item 5">
                      <h1 className="checkout_item_name">
                        {pageLanguage === "fa"
                          ? convertToPersian(defaultModelNameFa) + " سفارشی "
                          : "Custom " + defaultModelName}
                      </h1>
                      <div className="checkout_item_price_section 4">
                        <span
                          className={`checkout_item_price ${
                            hasDiscount ? "checkout_item_price_with_discount" : ""
                          }`}
                        >
                          {GetPrice(
                            hasDiscount ? obj1["Amount"] : obj["Price"],
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )}
                        </span>
                        {hasDiscount && (
                          <span className="checkout_item_price">
                            {GetPrice(
                              obj1["PayableAmount"],
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )}
                          </span>
                        )}
                      </div>
                    </div>

                    <h4 className="checkout_item_room_name">
                      {pageLanguage === "fa"
                        ? roomNameFa + " / " + WindowName
                        : roomName + " / " + WindowName}
                    </h4>

                    <Accordion>
                      <Accordion.Item eventKey="0">
                        <ContextAwareToggleViewDetails
                          eventKey="0"
                          textOnHide={t("View Details")}
                          textOnShow={t("Hide Details")}
                        />
                        <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                          <div className="basket_item_title_container 11">{desc}</div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    {hasDiscount && (
                      <span className="checkout_item_discount">
                        {t("Discount")} (
                        {GetPrice(obj1["Discount"], pageLanguage, t("TOMANS"), isTabletOrMobile)})
                      </span>
                    )}
                  </div>
                </li>
              );
              resolve();
            });
          });
        });
      Promise.all(promiseArr).then(() => {
      // console.log('2057 noShipping', tempNoShip);
       
      //  setNoShipping(tempNoShip);
      });
    } else {
      let cartObj2 = JSON.parse(localStorage.getItem("cart"));

      let categorizedItems = {
        product: [],
        drapery: [],
        swatches: [],
      };

      cartObj2?.drapery?.forEach((item) => {
        if (item.ProductId) {
          categorizedItems.product.push(item);
        } else if (item.FabricId) {
          categorizedItems.drapery.push(item);
        }
      });

      cartObj2?.swatches?.forEach((item) => {
        categorizedItems.swatches.push(item);
      });
      setProducts(categorizedItems.product);
      if (categorizedItems.drapery.length) {
        let tempDrapery = categorizedItems.drapery;
        let temp = [];
        let delArr = [];

        let draperiesTotalPrice = 0;
        let draperiesTotalInstall = 0;
        let draperiesTotalTransport = 0;
        let promiseArr = [];
        let tempNoShip = true;

        tempDrapery.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let tempPostObj = obj;
            if (obj["PreorderText"] === undefined) {
              // localStorage.removeItem("cart");
            } else {
              processAndSendOrder(tempPostObj, baseURLPrice).then(resolve);
            }
          });
        });
        tempDrapery = tempDrapery.filter((_, index) => !delArr.includes(index));
        Promise.all(promiseArr)
          .then(function(values) {
            let tempDraperiesTotalTransport = values.find(function(el) {
              return (
                el["data"] &&
                el["data"]["TransportationAmount"] &&
                el["data"]["TransportationAmount"] > 0
              );
            });
            if (
              tempDraperiesTotalTransport &&
              tempDraperiesTotalTransport["data"] &&
              tempDraperiesTotalTransport["data"]["TransportationAmount"]
            ) {
              draperiesTotalTransport = tempDraperiesTotalTransport["data"]["TransportationAmount"];
            } else {
              draperiesTotalTransport = 0;
            }

            let promiseArr = [];
            tempDrapery.forEach((obj1, index) => {
              promiseArr[index] = new Promise((resolve, reject) => {
                if (
                  values[index] === undefined ||
                  values[index].data === undefined ||
                  values[index].data["Price"] === 0
                ) {
                  // localStorage.removeItem("cart");
                  resolve();
                } else {
                  let obj = obj1["PreorderText"] || {};
                  let SewingModelId = obj["SewingModelId"];
                  let userProjects = projectData[obj["SewingModelId"]]
                    ? projectData[obj["SewingModelId"]]["data"]
                    : [];
                  let desc = [];
                  let temp1 = [];
                  let temp2 = [];
                  let temp3 = [];
                  let temp4 = [];
                  let temp5 = [];
                  let fabricColorFa = obj["FabricColorFa"];
                  let fabricColor = obj["FabricColorEn"];
                  let fabricDesignFa = obj["FabricDesignFa"];
                  let fabricDesign = obj["FabricDesignEn"];
                  let defaultModelNameFa = obj["ModelNameFa"];
                  let defaultModelName = obj["ModelNameEn"];
                  let roomNameFa = obj["RoomNameFa"];
                  let roomName = obj["RoomNameEn"];
                  let WindowName = obj["WindowName"] === undefined ? "" : obj["WindowName"];
                  let moreInfoInput =
                    obj["moreInfoInput"] === undefined ? "" : obj["moreInfoInput"];
                  let photoUrl = obj["PhotoUrl"];
                  let zipcode = obj["ZipCode"];
                  let hasDiscount = obj1["Discount"] > 0 && discountList.length > 0;
                  obj["Price"] = values[index].data["Price"] / obj1["WindowCount"];
                  obj1["Price"] = values[index].data["Price"] / obj1["WindowCount"];
                  const installPerUnit = values[index].data["InstallAmount"]
                    ? values[index].data["InstallAmount"]
                    : 0;
                  const itemQty = obj1["WindowCount"] || obj1["Count"] || 1;
                  obj["InstallAmount"] = installPerUnit;
                  obj1["InstallAmount"] = installPerUnit;
                  obj["TransportationAmount"] = values[index].data["TransportationAmount"]
                    ? values[index].data["TransportationAmount"]
                    : 0;
                  draperiesTotalPrice += values[index].data["Price"];
                  draperiesTotalInstall += installPerUnit * itemQty;

                  if (tempNoShip) {
                    tempNoShip = zipcode && zipcode !== "";
                  }

                  let promiseArr0 = [];

                  if (SewingModelId === "0099") {
                    promiseArr0[0] = new Promise((resolve, reject) => {
                      GetUserProjectData(obj1, false)
                        .then((cartValues) => {
                          let promiseArr4 = [];
                          if (cartValues["Accessories"] !== undefined) {
                            cartValues["Accessories"].forEach((obj, index) => {
                              if (
                                obj["DesignNameFa"] !== undefined &&
                                obj["DesignNameEn"] !== undefined
                              ) {
                                promiseArr4[index] = new Promise((resolve, reject) => {
                                  if (obj["DesignNameFa"] && obj["DesignNameEn"]) {
                                    temp4[index] = (
                                      <li className="cart_agree_item" key={"acc" + index}>
                                        <h1 className="cart_agree_item_title">
                                          {pageLanguage === "fa"
                                            ? obj["DesignNameFa"]
                                            : obj["DesignNameEn"]}
                                        </h1>
                                        <h2 className="cart_agree_item_desc">
                                          {t("agree_Qty")}
                                          {NumToFa(obj["Qty"], pageLanguage)}
                                        </h2>
                                      </li>
                                    );
                                  }
                                  resolve();
                                });
                              }
                            });
                          }

                          let promiseArr3 = [];
                          Object.keys(cartValues).forEach((key, index) => {
                            promiseArr3[index] = new Promise((resolve, reject) => {
                              let tempObj = userProjects.find((obj) => obj["cart"] === key);
                              if (tempObj === undefined || cartValues[key] === undefined) {
                                // window.location.reload();

                                resolve();
                              } else {
                                if (
                                  (key === "PanelTypeOption" &&
                                    cartValues["PanelTypeOption"] ===
                                      "Customize Style Per Curtain") ||
                                  (key === "Hardware" &&
                                    cartValues["Hardware"] ===
                                      "I Want To Customize Hardware Per Curtain")
                                ) {
                                  resolve();
                                } else if (
                                  tempObj["title"] !== "" &&
                                  tempObj["lang"].indexOf(pageLanguage) > -1
                                ) {
                                  let objLabel = "";
                                  if (
                                    key === "ControlType" &&
                                    cartValues["ControlType"] === "Motorized"
                                  ) {
                                    objLabel =
                                      pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(
                                            `${t(cartValues[key].toString())} / ${t(
                                              cartValues["MotorType"].toString()
                                            )}`
                                          ).toString()
                                        : `${t(cartValues[key].toString())} / ${t(
                                            cartValues["MotorType"].toString()
                                          )}`;
                                  } else if (
                                    key === "DraperyHardware" &&
                                    cartValues["DraperyHardware"] !== "None"
                                  ) {
                                    objLabel =
                                      t(cartValues[key].toString()) +
                                      " / " +
                                      (pageLanguage === "fa"
                                        ? cartValues["RailDesignFaA"]
                                        : cartValues["RailDesignEnA"]) +
                                      " \n " +
                                      (pageLanguage === "fa"
                                        ? cartValues["RailColorFaA"]
                                        : cartValues["RailColorEnA"]) +
                                      " / " +
                                      t(cartValues["BatonOptionA"]);
                                  } else if (
                                    key === "SheerHardware" &&
                                    cartValues["SheerHardware"] !== "None"
                                  ) {
                                    if (cartValues["RailDesignEnB"] === "Motorized Track") {
                                      objLabel =
                                        t(cartValues[key].toString()) +
                                        " / " +
                                        (pageLanguage === "fa"
                                          ? cartValues["RailDesignFaB"]
                                          : cartValues["RailDesignEnB"]);
                                    } else {
                                      objLabel =
                                        t(cartValues[key].toString()) +
                                        " / " +
                                        (pageLanguage === "fa"
                                          ? cartValues["RailDesignFaB"]
                                          : cartValues["RailDesignEnB"]) +
                                        " \n " +
                                        (pageLanguage === "fa"
                                          ? cartValues["RailColorFaB"]
                                          : cartValues["RailColorEnB"]) +
                                        " / " +
                                        (cartValues["BatonOptionB"]
                                          ? t(cartValues["BatonOptionB"])
                                          : t(cartValues["ControlPositionB"]));
                                    }
                                  } else if (
                                    key === "PrivacyLayerHardware" &&
                                    cartValues["PrivacyLayerHardware"] !== "None"
                                  ) {
                                    if (cartValues["RailDesignEnC"] === "Motorized Track") {
                                      objLabel =
                                        t(cartValues[key].toString()) +
                                        " / " +
                                        (pageLanguage === "fa"
                                          ? cartValues["RailDesignFaC"]
                                          : cartValues["RailDesignEnC"]);
                                    } else {
                                      objLabel =
                                        t(cartValues[key].toString()) +
                                        " / " +
                                        (pageLanguage === "fa"
                                          ? cartValues["RailDesignFaC"]
                                          : cartValues["RailDesignEnC"]) +
                                        " \n " +
                                        (pageLanguage === "fa"
                                          ? cartValues["RailColorFaC"]
                                          : cartValues["RailColorEnC"]) +
                                        " / " +
                                        (cartValues["BatonOptionC"]
                                          ? t(cartValues["BatonOptionC"])
                                          : t(cartValues["ControlPositionC"]));
                                    }
                                  } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                                    objLabel =
                                      t("agree_Qty") +
                                      NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                                  } else if (key === "HandCurtainEn2" || key === "HandCurtainFa2") {
                                    objLabel =
                                      t("agree_Qty") +
                                      NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                                  } else if (tempObj["titleValue"] === null || true) {
                                    if (tempObj["titlePostfix"] === "") {
                                      objLabel =
                                        pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              `${t(cartValues[key].toString())}`
                                            ).toString()
                                          : t(cartValues[key].toString());
                                    } else {
                                      objLabel =
                                        pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              `${cartValues[key]}`
                                            ).toString() + t(tempObj["titlePostfix"])
                                          : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                                    }
                                  } else {
                                    if (
                                      tempObj["titleValue"][cartValues[key].toString()] === null
                                    ) {
                                      if (tempObj["titlePostfix"] === "") {
                                        objLabel = t(cartValues[key].toString());
                                      } else {
                                        objLabel =
                                          pageLanguage === "fa"
                                            ? NumberToPersianWord.convertEnToPe(
                                                `${cartValues[key]}`
                                              ).toString() + t(tempObj["titlePostfix"])
                                            : cartValues[key].toString() +
                                              t(tempObj["titlePostfix"]);
                                      }
                                    } else {
                                      objLabel = t(
                                        tempObj["titleValue"][cartValues[key].toString()]
                                      );
                                    }
                                  }
                                  if (tempObj["fabric"] === undefined) {
                                    temp5[tempObj["order"]] = (
                                      <li className="cart_agree_item" key={key}>
                                        <h1 className="cart_agree_item_title">
                                          {t(tempObj["title"])}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                      </li>
                                    );
                                    resolve();
                                  } else if (tempObj["fabric"] === 1) {
                                    temp1[tempObj["order"]] = (
                                      <li className="cart_agree_item" key={key}>
                                        <h1 className="cart_agree_item_title">
                                          {t(tempObj["title"])}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                      </li>
                                    );
                                    resolve();
                                  } else if (tempObj["fabric"] === 2) {
                                    temp2[tempObj["order"]] = (
                                      <li className="cart_agree_item" key={key}>
                                        <h1 className="cart_agree_item_title">
                                          {t(tempObj["title"])}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                      </li>
                                    );
                                    resolve();
                                  } else if (tempObj["fabric"] === 3) {
                                    temp3[tempObj["order"]] = (
                                      <li className="cart_agree_item" key={key}>
                                        <h1 className="cart_agree_item_title">
                                          {t(tempObj["title"])}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                      </li>
                                    );
                                    resolve();
                                  } else {
                                    resolve();
                                  }
                                } else {
                                  resolve();
                                }
                              }
                            });
                          });
                          Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                            desc[40] = (
                              <>
                                <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                  <h1 className="cart_agree_item_fabrics_sorted_title">
                                    {t("General Details")}
                                  </h1>
                                  <ul>{temp5}</ul>
                                </li>
                                {cartValues["FabricId"] && (
                                  <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                                    <h1 className="cart_agree_item_fabrics_sorted_title">
                                      {t("Drapery")}
                                    </h1>
                                    <ul>
                                      <li className="cart_agree_item">
                                        <h1 className="cart_agree_item_title">
                                          {t("Fabric & Color")}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc">
                                          {pageLanguage === "fa"
                                            ? cartValues["FabricDesignFa"] +
                                              " / " +
                                              cartValues["FabricColorFa"]
                                            : CapitalizeAllWords(
                                                cartValues["FabricDesignEn"] +
                                                  " / " +
                                                  cartValues["FabricColorEn"]
                                              )}
                                        </h2>
                                      </li>
                                      {cartValues["BorderOrTrimId"] &&
                                        cartValues["borderPosition"] && (
                                          <li className="cart_agree_item">
                                            <h1 className="cart_agree_item_title">
                                              {t("Decorative Border")}&nbsp;
                                            </h1>
                                            <h2 className="cart_agree_item_desc">
                                              {pageLanguage === "fa"
                                                ? cartValues["BorderOrTrimDesignFa"] +
                                                  " / " +
                                                  cartValues["BorderOrTrimColorFa"] +
                                                  " \n " +
                                                  t(cartValues["borderPosition"])
                                                : CapitalizeAllWords(
                                                    cartValues["BorderOrTrimDesignEn"] +
                                                      " / " +
                                                      cartValues["BorderOrTrimColorEn"] +
                                                      " \n " +
                                                      t(cartValues["borderPosition"])
                                                  )}
                                            </h2>
                                          </li>
                                        )}
                                      {cartValues["BorderOrTrimId"] &&
                                        !cartValues["borderPosition"] && (
                                          <li className="cart_agree_item">
                                            <h1 className="cart_agree_item_title">
                                              {t("Decorative Trim")}&nbsp;
                                            </h1>
                                            <h2 className="cart_agree_item_desc">
                                              {pageLanguage === "fa"
                                                ? cartValues["BorderOrTrimDesignFa"] +
                                                  " / " +
                                                  cartValues["BorderOrTrimColorFa"]
                                                : CapitalizeAllWords(
                                                    cartValues["BorderOrTrimDesignEn"] +
                                                      " / " +
                                                      cartValues["BorderOrTrimColorEn"]
                                                  )}
                                            </h2>
                                          </li>
                                        )}
                                      {temp1}
                                    </ul>
                                  </li>
                                )}
                                {cartValues["FabricId2"] && (
                                  <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                                    <h1 className="cart_agree_item_fabrics_sorted_title">
                                      {t("Sheer")}
                                    </h1>
                                    <ul>
                                      <li className="cart_agree_item">
                                        <h1 className="cart_agree_item_title">
                                          {t("Fabric & Color")}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc">
                                          {pageLanguage === "fa"
                                            ? cartValues["FabricDesignFa2"] +
                                              " / " +
                                              cartValues["FabricColorFa2"]
                                            : CapitalizeAllWords(
                                                cartValues["FabricDesignEn2"] +
                                                  " / " +
                                                  cartValues["FabricColorEn2"]
                                              )}
                                        </h2>
                                      </li>
                                      {cartValues["BorderOrTrimId2"] &&
                                        cartValues["borderPosition2"] && (
                                          <li className="cart_agree_item">
                                            <h1 className="cart_agree_item_title">
                                              {t("Decorative Border")}&nbsp;
                                            </h1>
                                            <h2 className="cart_agree_item_desc">
                                              {pageLanguage === "fa"
                                                ? cartValues["BorderOrTrimDesignFa2"] +
                                                  " / " +
                                                  cartValues["BorderOrTrimColorFa2"] +
                                                  " \n " +
                                                  t(cartValues["borderPosition2"])
                                                : CapitalizeAllWords(
                                                    cartValues["BorderOrTrimDesignEn2"] +
                                                      " / " +
                                                      cartValues["BorderOrTrimColorEn2"] +
                                                      " \n " +
                                                      t(cartValues["borderPosition2"])
                                                  )}
                                            </h2>
                                          </li>
                                        )}
                                      {cartValues["BorderOrTrimId2"] &&
                                        !cartValues["borderPosition2"] && (
                                          <li className="cart_agree_item">
                                            <h1 className="cart_agree_item_title">
                                              {t("Decorative Trim")}&nbsp;
                                            </h1>
                                            <h2 className="cart_agree_item_desc">
                                              {pageLanguage === "fa"
                                                ? cartValues["BorderOrTrimDesignFa2"] +
                                                  " / " +
                                                  cartValues["BorderOrTrimColorFa2"]
                                                : CapitalizeAllWords(
                                                    cartValues["BorderOrTrimDesignEn2"] +
                                                      " / " +
                                                      cartValues["BorderOrTrimColorEn2"]
                                                  )}
                                            </h2>
                                          </li>
                                        )}
                                      {temp2}
                                    </ul>
                                  </li>
                                )}
                                {cartValues["PrivacyLayer"] &&
                                  cartValues["PrivacyLayer"] !== "none" && (
                                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                                      <h1 className="cart_agree_item_fabrics_sorted_title">
                                        {t("Privacy Layer")}
                                      </h1>
                                      <ul>
                                        <li className="cart_agree_item">
                                          <h1 className="cart_agree_item_title">
                                            {t("Fabric & Color")}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {pageLanguage === "fa"
                                              ? cartValues["SheersDesignFa"] +
                                                " / " +
                                                cartValues["SheersColorFa"]
                                              : CapitalizeAllWords(
                                                  cartValues["SheersDesignEn"] +
                                                    " / " +
                                                    cartValues["SheersColorEn"]
                                                )}
                                          </h2>
                                        </li>
                                        {temp3}
                                      </ul>
                                    </li>
                                  )}
                                {!!temp4.length && (
                                  <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                                    <h1 className="cart_agree_item_fabrics_sorted_title">
                                      {t("Accessories")}
                                    </h1>
                                    <ul>{temp4}</ul>
                                  </li>
                                )}

                                {moreInfoInput !== "" && (
                                  <li className="cart_agree_item">
                                    <h1 className="cart_agree_item_title">
                                      {t("Order Notes")}&nbsp;
                                    </h1>
                                    <ShowMoreLineLimited moreInfoInput={moreInfoInput} lines={3} />
                                  </li>
                                )}
                              </>
                            );
                            resolve();
                          });
                        })
                        .catch((err) => {
                          console.log(err);
                          resolve();
                        });
                    });
                  } else {
                    Object.keys(obj).forEach((key, i) => {
                      promiseArr0[i] = new Promise((resolve, reject) => {
                        let tempObj = userProjects.find((obj) => obj["apiLabel"] === key);
                        if (tempObj === undefined || obj[key] === undefined) {
                          resolve();
                        } else {
                          if (
                            tempObj["title"] !== "" &&
                            tempObj["lang"].indexOf(pageLanguage) > -1
                          ) {
                            let objLabel = "";
                            let apiValue =
                              obj[tempObj["apiLabel"]] === null
                                ? "null"
                                : obj[tempObj["apiLabel"]].toString();
                            if (
                              tempObj["apiLabel"] === "ControlType" &&
                              obj["ControlType"] === "Motorized"
                            ) {
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${t(obj[key].toString())} / ${t(
                                        obj["MotorType"].toString()
                                      )}`
                                    ).toString()
                                  : `${t(obj[key].toString())} / ${t(obj["MotorType"].toString())}`;
                            } else if (tempObj["titleValue"] === null) {
                              if (tempObj["titlePostfix"] === "") {
                                objLabel =
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(
                                        `${t(apiValue.toString())}`
                                      ).toString()
                                    : t(apiValue.toString());
                              } else {
                                objLabel =
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(`${apiValue}`).toString() +
                                      t(tempObj["titlePostfix"])
                                    : apiValue.toString() + t(tempObj["titlePostfix"]);
                              }
                            } else {
                              if (tempObj["titleValue"][apiValue.toString()] === null) {
                                if (tempObj["titlePostfix"] === "") {
                                  objLabel = t(apiValue.toString());
                                } else {
                                  objLabel =
                                    pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(
                                          `${apiValue}`
                                        ).toString() + t(tempObj["titlePostfix"])
                                      : apiValue.toString() + t(tempObj["titlePostfix"]);
                                }
                              } else {
                                objLabel = t(tempObj["titleValue"][apiValue.toString()]);
                              }
                            }
                            desc[tempObj["order"]] = (
                              <div className="basket_item_title_desc" key={key}>
                                <h3>{t(tempObj["title"])}&nbsp;</h3>
                                <h4>{objLabel}</h4>
                              </div>
                            );
                            resolve();
                          } else {
                            resolve();
                          }
                        }
                      });
                    });
                  }

                  Promise.all(promiseArr0).then(() => {
                    if (obj1["SewingModelId"] === "0326") {
                      desc = [
                        <div className="basket_item_title_desc" key={"fabric/color"}>
                          <h3>{t("Fabric/Color")}&nbsp;</h3>
                          <h4>
                            {obj1["SodFabrics"].map((item, i) => (
                              <div key={i} className="dk_curtain_preview_detail">
                                <h2>
                                  {(pageLanguage === "en"
                                    ? CapitalizeAllWords(item["FabricObj"]["DesignEnName"])
                                    : item["FabricObj"]["DesignName"]
                                  ).toString() +
                                    " / " +
                                    (pageLanguage === "en"
                                      ? CapitalizeAllWords(item["FabricObj"]["ColorEnName"])
                                      : item["FabricObj"]["ColorName"]
                                    ).toString()}
                                </h2>
                                <h5>&nbsp;X</h5>
                                <h3>{NumToFa(item["Qty"], pageLanguage)}</h3>
                              </div>
                            ))}
                          </h4>
                        </div>,
                        ...desc,
                      ];
                    }
                    temp[tempDrapery.length - index - 1] = (
                      <li className="checkout_item_container" key={index}>
                        <div className="checkout_item_image_container">
                          <img src={imgUrl(photoUrl)} alt="" className="checkout_item_img" />
                          <p className="checkout_item_image_qty 1">
                            {pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${obj1["Count"]}`)
                              : obj1["Count"]}
                          </p>
                        </div>
                        <div className="checkout_item_desc_container">
                          <div className="checkout_item 6">
                            <h1 className="checkout_item_name">
                              {pageLanguage === "fa"
                                ? convertToPersian(defaultModelNameFa) + " سفارشی "
                                : "Custom " + defaultModelName}
                            </h1>
                            <div className="checkout_item_price_section 5">
                              <span
                                className={`checkout_item_price ${
                                  hasDiscount ? "checkout_item_price_with_discount" : ""
                                }`}
                              >
                                {GetPrice(
                                  obj1["Price"] * obj1["Count"],
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )}
                              </span>
                              {hasDiscount && (
                                <span className="checkout_item_price">
                                  {GetPrice(
                                    obj1["Price"] * obj1["Count"] - obj["Discount"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                </span>
                              )}
                            </div>
                          </div>

                          <h4 className="checkout_item_room_name">
                            {pageLanguage === "fa"
                              ? roomNameFa + " / " + WindowName
                              : roomName + " / " + WindowName}
                          </h4>
                          <Accordion>
                            <Accordion.Item eventKey="0">
                              <ContextAwareToggleViewDetails
                                eventKey="0"
                                textOnHide={t("View Details")}
                                textOnShow={t("Hide Details")}
                              />
                              <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                <div className="basket_item_title_container 25">{desc}</div>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                          {hasDiscount && (
                            <span className="checkout_item_discount">
                              {t("Discount")} (-2-
                              {GetPrice(
                                obj["Discount"],
                                pageLanguage,
                                t("TOMANS"),
                                isTabletOrMobile
                              )}
                              )
                            </span>
                          )}
                        </div>
                      </li>
                    );
                    resolve();
                  });
                }
              });
            });

            Promise.all(promiseArr).then(() => {
              
              if (localStorage.getItem("cart") !== null) {
                let cartObjects = JSON.parse(localStorage.getItem("cart"));
                cartObjects["drapery"] = tempDrapery;
                // localStorage.setItem("cart", JSON.stringify(cartObjects));
              } else {
                setCart({});
              }
              setSubTotalPrice(draperiesTotalPrice);
              setInstallPrice(draperiesTotalInstall);
              setTransportPrice(draperiesTotalTransport);
              setTotalPrice(draperiesTotalPrice + draperiesTotalInstall + draperiesTotalTransport);
              setNoShipping(tempNoShip);
            });
          })
          .catch((err) => {
            console.log(err);
            
            setSubTotalPrice(0);
            setInstallPrice(0);
            setTransportPrice(0);
            setTotalPrice(0);
            setTotalSaving(0);
            setNoShipping(true);
          });
      } else {
       
        setSubTotalPrice(0);
        setInstallPrice(0);
        setTransportPrice(0);
        setTotalPrice(0);
        setTotalSaving(0);
        setNoShipping(true);
      }
    }
  }, [drapery]);

  useEffect(() => {
    if (isLoggedIn) {
      let tempTotal = swatches.reduce((sum, item) => sum + item.PayableAmount, 0);
     
      if (swatchOnly && swatchOnly === "Swatches") {
        setSubTotalPrice(tempTotal);
        setTotalPrice(tempTotal);
      }
    }
  }, [swatches]);

  useEffect(() => {
    if (discounts.length > 0) {
      let tempDiscounts = JSON.parse(JSON.stringify(discounts));
      let tempArr = [];
      let promise1 = new Promise((resolve, reject) => {
        tempDiscounts.forEach((tempObj, index) => {
          tempArr[index] = (
            <span className="discount_applied" key={index}>
              <img
                src={require("../Images/public/discount1.svg").default}
                className="img-fluid discount_applied_img"
                alt=""
              />
              <p className="discount_applied_text">{tempObj["Code"]}</p>
              <button
                className="btn-close discount_applied_remove"
                onClick={() => removeDiscount(tempObj["Code"])}
              />
            </span>
          );

          if (index === tempDiscounts.length - 1) {
            resolve();
          }
        });
      });

      promise1.then(() => {
        setDiscountList(tempArr);
      });
    } else {
      setDiscountList([]);
    }
  }, [discounts]);

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      let pageLanguage1 = tempLang.slice(1, 3).join("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
      i18n.changeLanguage(pageLanguage1);
      document.body.dir = pageLanguage1 === "fa" ? "rtl" : "ltr";
      document.body.className = pageLanguage1 === "fa" ? "font_farsi" : "font_en";
    }
    if (localStorage.getItem("user") !== null && isLoggedIn) {
      let tempObj = JSON.parse(localStorage.getItem("user"));
      setUserName(
        jwt(tempObj["access_token"])["FirstName"] + " " + jwt(tempObj["access_token"])["LastName"]
      );
      setUserEmail(
        jwt(tempObj["access_token"])["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"]
      );
      getUserAddress();
    }
    const tempLang = location.pathname.split("");
    getCities(tempLang.slice(1, 3).join(""));
  }, [location.pathname, isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn) {
      const cartData = localStorage.getItem("cart");
      if (cartData) {
        let cartObj = JSON.parse(cartData);
        let discountList = cartObj["discountList"] || [];
        if (discountList.length > 0) {
          let postObj = {
            CartId: 0,
            UserId: 0,
            TotalAmount: 0,
            InstallAmount: 0,
            TransportationAmount: 0,
            TotalDiscount: 0,
            PayableAmount: 0,
            CartDetails: [],
            DiscountCodes: discountList.length > 1 ? discountList.slice(1) : [],
          };

          let DiscountCode = discountList.map((item) => item.Code);
          let draperies = cartObj["drapery"] || [];
          let cartIndex = 0;

          console.log(`draperies`, draperies);

          draperies.forEach((item) => {
            let cartDetail;

            if (item.ProductId) {
              cartDetail = {
                ...item,
                CartDetailId: cartIndex++,
                CartId: 0,
                Discount: 0,
              };
            } else {
              cartDetail = {
                CartDetailId: cartIndex++,
                CartId: 0,
                Discount: 0,
                SewingOrder: { ...item },
              };
            }

            postObj.CartDetails.push(cartDetail);
            postObj.TotalAmount += (item.Price || 0) * (item.Count || 1);
          });

          postObj.InstallAmount = draperies.reduce(
            (sum, item) => sum + (item.InstallAmount || 0) * (item.Count || 1),
            0
          );
          const firstWithShip = draperies.find((d) => d.ZipCode && d.TransportationAmount);
          if (firstWithShip) postObj.TransportationAmount = firstWithShip.TransportationAmount;

          postObj.PayableAmount =
            postObj.TotalAmount + postObj.InstallAmount + postObj.TransportationAmount;

          axios
            .post(baseURLAddDiscountGuest, postObj, {
              params: { code: DiscountCode[0] || "" },
            })
            .then((response) => {
              const updatedCartDetails = response.data["CartDetails"].map((item) => {
                if (item.ProductId) {
                  return item;
                } else if (item.SewingOrder) {
                  return {
                    ...item.SewingOrder,
                  };
                }
                return item;
              });

              setDrapery(updatedCartDetails);
              setTotalSaving(response.data["TotalDiscount"]);
              setDiscounts(response.data["DiscountCodes"]);
              setPriceTotal(response.data);
              setDiscount("");
              setDiscountErr("");

              const updatedCart = JSON.parse(localStorage.getItem("cart"));
              response.data["CartDetails"].forEach((detail) => {
                let draperyIndex = detail.CartDetailId;
                updatedCart.drapery[draperyIndex]["Discount"] = detail.Discount;
              });
              localStorage.setItem("cart", JSON.stringify(updatedCart));
              setCartChanged((prev) => prev + 1);
            })
            .catch((err) => {
              console.error("API Error:", err);
            });
        }
      }
    }
  }, [isLoggedIn]);

  const totalPriceBuy = products?.reduce((acc, product) => {
    const priceToUse = product.DiscountedPrice ?? product.Price;
    return acc + product.Count * priceToUse;
  }, 0);

  const guestDraperyProducts = useMemo(() => {
    const draperyItems = drapery || [];
    const productItems = cart?.product || [];
    return [...draperyItems, ...productItems].filter((item) => item.TypeId !== 6402);
  }, [drapery, cart]);

  const hasApiCartProducts = isLoggedIn ? product2.length > 0 : productGuest.length > 0;

  const getCityLabel = (addr) =>
    pageLanguage === "fa" ? addr["CityName"] : addr["CityEnName"];

  const getStateLabel = (addr) =>
    pageLanguage === "fa" ? addr["StateName"] : addr["StateEnName"];

  const formatUserAddressLines = (addr) => {
    const name = formatAddressDigits(
      `${addr["FirstName"] || ""} ${addr["LastName"] || ""}`.trim(),
      pageLanguage
    );
    const state = formatAddressDigits((getStateLabel(addr) || "").trim(), pageLanguage);
    const city = formatAddressDigits((getCityLabel(addr) || "").trim(), pageLanguage);
    const location =
      state && city && state.toLowerCase() !== city.toLowerCase()
        ? `${state} , ${city}`
        : state || city;
    const line1 = location ? `${name}, ${location}` : name;

    const line2 = [addr["Address"], addr["Address2"]]
      .map((part) => formatAddressDigits(part ? String(part).trim() : "", pageLanguage))
      .filter(Boolean)
      .join(", ");

    const zipRaw = (addr["ZipCode"] || "").trim();
    const telRaw = (addr["Tel"] || "").trim();
    const mobileRaw = (addr["Mobile"] || "").trim();
    const zip = NumToFa(zipRaw, pageLanguage);
    const tel = NumToFa(telRaw, pageLanguage);
    const mobile = NumToFa(mobileRaw, pageLanguage);
    const phones = [];
    if (tel) phones.push(tel);
    if (mobile && mobileRaw !== telRaw) phones.push(mobile);
    const line3 = [zip, phones.join(" - ")].filter(Boolean).join(" - ");

    return { line1, line2, line3 };
  };

  const formatDeleteAddressSummary = (addr) => {
    if (!addr) return "";
    const name = formatAddressDigits(
      `${addr["FirstName"] || ""} ${addr["LastName"] || ""}`.trim(),
      pageLanguage
    );
    const city = formatAddressDigits((getCityLabel(addr) || "").trim(), pageLanguage);
    const state = formatAddressDigits((getStateLabel(addr) || "").trim(), pageLanguage);
    const region =
      state && city && state.toLowerCase() !== city.toLowerCase()
        ? `${city}, ${state}`
        : city || state;
    const streetParts = [addr["Address"], addr["Address2"]]
      .map((part) => formatAddressDigits(part ? String(part).trim() : "", pageLanguage))
      .filter(Boolean)
      .join(", ");
    const parts = [name, t("Iran"), region, streetParts].filter(Boolean);
    return parts.join(", ");
  };

  const deleteAddressTarget =
    deleteAddressId != null
      ? userAddress.find((item) => item["CustomerAddressId"] === deleteAddressId)
      : null;
  const deleteAddressSummary = deleteAddressTarget
    ? formatDeleteAddressSummary(deleteAddressTarget)
    : "";

  const getDeleteAddressConfirmMessage = () => {
    if (!deleteAddressSummary) return t("delete_address_question");
    if (pageLanguage === "fa") {
      return `${t("delete_address_question")} ${deleteAddressSummary} ${t(
        "delete_address_question_suffix"
      )}`;
    }
    return `${t("delete_address_question")} ${deleteAddressSummary}?`;
  };

  const getAddressSummary = () => {
    const selectedId =
      selectedAddress.length && selectedAddress[0].value !== -1
        ? selectedAddress[0].value
        : null;

    if (selectedId) {
      const addr = userAddress.find((item) => item["CustomerAddressId"] === selectedId);
      if (addr) {
        return formatUserAddressLines(addr);
      }
    }

    if (address1["Name"] || address1["Address1"]) {
      const name = formatAddressDigits(
        `${address1["Name"] || ""} ${address1["Last"] || ""}`.trim(),
        pageLanguage
      );
      const cityLabel = formatAddressDigits((selectedCity[0]?.label || "").trim(), pageLanguage);
      const line1 = cityLabel ? `${name}, ${cityLabel}` : name;
      const line2 = [address1["Address1"], address1["Address2"]]
        .map((part) => formatAddressDigits(part ? String(part).trim() : "", pageLanguage))
        .filter(Boolean)
        .join(", ");
      const line3 = NumToFa((address1["ZipCode"] || "").trim(), pageLanguage);
      return { line1, line2, line3 };
    }

    return null;
  };

  const isAddressOptionSelected = (addressId) =>
    selectedAddress.length > 0 && selectedAddress[0].value === addressId;

  const handleAddressOptionSelect = (option) => {
    if (option.value === -1) {
      openAddAddressModal();
      return;
    }
    setSelectedAddress([option]);
    setAddressMenuOpenId(null);
    setAllAddress(option.value);
  };

  const setEditAddressField = (field, value) => {
    setEditAddressForm((prev) => ({ ...prev, [field]: value }));
  };

  const getEditAddressDisplayValue = (value, isAddressField = false) => {
    if (!value) return value;
    if (pageLanguage !== "fa") return value;
    return isAddressField
      ? formatAddressDigits(String(value), pageLanguage)
      : NumToFa(String(value), pageLanguage);
  };

  const normalizeAddressInputValue = (rawValue, numericOnly = false) => {
    let normalized = NumberToPersianWord.convertPeToEn(String(rawValue));
    if (numericOnly) {
      normalized = normalized.replace(/\D/g, "");
    }
    return normalized;
  };

  const setAddressFromInput = (num, refIndex, rawValue, numericOnly = false) => {
    setAddress(num, refIndex, normalizeAddressInputValue(rawValue, numericOnly));
  };

  const openAddAddressModal = () => {
    setAddressMenuOpenId(null);
    let defaultName = "";
    let defaultLast = "";
    if (localStorage.getItem("user") !== null && isLoggedIn) {
      const tempObj = JSON.parse(localStorage.getItem("user"));
      defaultName = jwt(tempObj["access_token"])["FirstName"] || "";
      defaultLast = jwt(tempObj["access_token"])["LastName"] || "";
    }
    setEditAddressForm({
      CustomerAddressId: "",
      Name: defaultName,
      Last: defaultLast,
      Address1: "",
      Address2: "",
      ZipCode: "",
      PhoneNumber: "",
      IsDefault: false,
      StateId: "",
      CityId: "",
    });
    setEditSelectedState([]);
    setEditSelectedCity([]);
    setEditCities([]);
    setEditAddressMode("add");
    setShowEditAddressModal(true);
  };

  const openEditAddressModal = (addr) => {
    setAddressMenuOpenId(null);
    setEditAddressMode("edit");
    const stateOption = findStateOptionForAddress(addr);
    const stateIdForCities = stateOption?.value ?? addr["StateId"] ?? addr["ZoneNo"];
    const stateLabel =
      pageLanguage === "fa" ? addr["StateName"] : addr["StateEnName"];
    const cityLabel = pageLanguage === "fa" ? addr["CityName"] : addr["CityEnName"];

    setEditAddressForm({
      CustomerAddressId: addr["CustomerAddressId"],
      Name: addr["FirstName"] || "",
      Last: addr["LastName"] || "",
      Address1: addr["Address"] || "",
      Address2: addr["Address2"] || "",
      ZipCode: addr["ZipCode"] || "",
      PhoneNumber: addr["Mobile"] || "",
      IsDefault: !!addr["IsDefault"],
      StateId: stateIdForCities || "",
      CityId: addr["CityId"] || "",
    });

    setEditSelectedState(
      stateOption
        ? [stateOption]
        : stateIdForCities
          ? [{ value: stateIdForCities, label: stateLabel || "" }]
          : []
    );

    if (addr["CityId"]) {
      setEditSelectedCity([{ value: addr["CityId"], label: cityLabel || "" }]);
    } else {
      setEditSelectedCity([]);
    }

    if (stateIdForCities) {
      getEditCities(pageLanguage, stateIdForCities, addr["CityId"]);
    } else {
      setEditCities([]);
    }
    setShowEditAddressModal(true);
  };

  const saveEditAddress = () => {
    const form = editAddressForm;
    const resolvedStateId = editSelectedState[0]?.value ?? form.StateId;
    const resolvedCityId = editSelectedCity[0]?.value ?? form.CityId;

    if (
      !form.Name ||
      !form.Last ||
      !form.Address1 ||
      !form.ZipCode ||
      !form.PhoneNumber ||
      !resolvedStateId ||
      !resolvedCityId
    ) {
      return;
    }

    const payload = {
      firstName: form.Name,
      lastName: form.Last,
      cityId: resolvedCityId,
      address: form.Address1,
      address2: form.Address2 || "",
      StateId: resolvedStateId,
      zipCode: form.ZipCode,
      tel: form.PhoneNumber,
      mobile: form.PhoneNumber,
      IsDefault: form.IsDefault,
    };

    if (editAddressMode === "edit") {
      payload.CustomerAddressId = String(form.CustomerAddressId);
    }

    const addressUrl = editAddressMode === "add" ? baseURLAddAddress : baseURLEditAddress;

    setEditAddressSaving(true);
    axios
      .post(addressUrl, payload, {
        headers: authHeader(),
      })
      .then((response) => {
        const editedId = form.CustomerAddressId;
        setShowEditAddressModal(false);
        setEditAddressSaving(false);
        getUserAddress();
        if (editAddressMode === "edit") {
          if (selectedAddress.length && selectedAddress[0].value === editedId) {
            setAllAddress(editedId);
          }
        } else {
          const newId =
            response.data?.CustomerAddressId ??
            response.data?.customerAddressId ??
            response.data;
          if (newId && typeof newId !== "object") {
            setAllAddress(newId);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setEditAddressSaving(false);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              saveEditAddress();
            } else {
              navigate("/" + pageLanguage);
            }
          });
        }
      });
  };

  const handleAddressEdit = (addr) => {
    openEditAddressModal(addr);
  };

  const handleAddressDelete = (addr) => {
    setAddressMenuOpenId(null);
    setDeleteAddressId(addr["CustomerAddressId"]);
    setShowDeleteAddressModal(true);
  };

  const confirmDeleteAddress = () => {
    if (deleteAddressId) {
      deleteCheckoutAddress(deleteAddressId);
    }
  };

  const handlePaymentSuccessModalClose = () => {
    setShowPaymentSuccessModal(false);
    navigate("/" + pageLanguage);
  };

  const handleContinueToPayment = async () => {
    if (paymentContinuing) return;

    const isValid = validateInputs();
    if (!isValid) {
      console.log("اعتبارسنجی ناموفق");
      return;
    }

    if (isLoggedIn) {
      const addressId = getLoggedInShippingAddressId();
      if (!addressId) {
        console.error("هیچ آدرسی انتخاب نشده است");
        return;
      }

      const methodId = getSelectedShippingMethodId();
      if (!methodId) {
        console.error("هیچ روش ارسالی انتخاب نشده است");
        return;
      }

      setPaymentContinuing(true);
      try {
        const response = await axios.get(checkoutPayment, {
          params: {
            addressId: Number(addressId),
            methodId,
          },
          headers: authHeader(),
        });
        if (response?.data?.InvoiceId) {
          setShowPaymentSuccessModal(true);
        }
      } catch (error) {
        console.error("خطا در پرداخت", error);
      } finally {
        setPaymentContinuing(false);
      }
      return;
    }

    if (!selectedAddress || selectedAddress.length === 0) {
      console.error("هیچ آدرسی انتخاب نشده است");
      return;
    }

    const selectedValue = selectedAddress[0].value;
    if (selectedValue === -1) {
      return;
    }

    console.log("بعدا نوشته شود بخش کاربر مهمان");
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  const addressSummary = getAddressSummary();

  return (
    <div className={`basket_page_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
      <div className="checkout_container">
        <div className="checkout_left">
          <div className="Logo">
            <Link to="/">{pageLanguage === "en" ? <Logoen /> : <Logofa />}</Link>
          </div>

          <div className="checkout_left_container">
            <div className="checkout_left_info">
              <div className="checkout_left_info_login_section">
                <div className="checkout_left_info_flex checkout_left_info_flex_title checkout_left_info_flex-new">
                  <div className="checkout_left_info_flex_left">
                    <h1 className="checkout_left_info_title">{t("CONTACT INFORMATION")}</h1>
                  </div>
                  <div className="checkout_left_info_flex_right checkout_left_info_flex_right-new">
                    {!isLoggedIn && (
                      <span
                        className="checkout_left_info_title"
                        style={{ textTransform: "uppercase" }}
                        onClick={() => setShowSideLoginModal(true)}
                        // onClick={() =>
                        //   dispatch({
                        //     type: ShowLoginModal,
                        //   })
                        // }
                      >
                        {t("Already have an account? ")}
                        <p style={{ display: "inline-block", textDecoration: "underline", cursor: "pointer",textUnderlineOffset: "4px" }}>{t("Log in")}</p>
                      </span>
                    )}
                  </div>
                </div>
                <div className="checkout_left_info_flex">
                  {!isLoggedIn && (
                    <div className="checkout_left_info_flex_left">
                      <input
                        type="text"
                        placeholder={t("Email*")}
                        className="form-control"
                        name="Email"
                        value={loginInfo.email}
                        onChange={(e) => {
                          let temp = JSON.parse(JSON.stringify(loginInfo));
                          temp.email = e.target.value;
                          console.log(`temp`, temp);
                          setLoginInfo(temp);
                          if (e.target.value.length > 0) {
                            setEmailNotExist(false);
                            if (validateEmail(e.target.value)) {
                              setEmailNotValid(false);
                            }
                          }
                        }}
                      />
                      {emailNotValid && (
                        <div className="input_not_valid">
                          {emailError[pageLanguage][emailErrorState]["error"]}
                        </div>
                      )}
                      {emailNotExist && (
                        <div className="input_not_valid">{t("Email Required.")}</div>
                      )}
                    </div>
                  )}
                  {isLoggedIn && (
                    <div className="checkout_left_info_flex_left">
                      <span className="logged_user">
                        <h1 className="logged_user_name">{userName}</h1>
                        <h2 className="logged_user_email">({userEmail})</h2>
                      </span>
                      <span className="user_logout text_underline"
                       onClick={() => {
                        if (userAddress.length > 0) {
                          setAddress1({
                            id: "",
                            Name: "",
                            Last: "",
                            Address1: "",
                            Address2: "",
                            State: "1",
                            City: "1",
                            ZipCode: "",
                            PhoneNumber: "",
                          });
                        }
                        logoutUser();
                        setShippingMethods([]);
                       }}>
                        {t("LOG OUT")}
                      </span>
                    </div>
                  )}
                  <div className="checkout_left_info_flex_right"></div>
                </div>
                {!isLoggedIn && (
                  <div className="checkout_left_info_shipping_agree">
                    <div className="checkout_left_info_flex">
                      <div className="checkout_left_info_flex_checkbox">
                        <input
                          type="checkbox"
                          checked={emailNews}
                          onChange={(e) => {
                            setEmailNews(e.target.checked);
                          }}
                          id="emailNews"
                        />
                        <label htmlFor="emailNews" className="checkbox_label 1">
                          <img
                            className="checkbox_label_img checkmark1 img-fluid"
                            src={require("../Images/public/checkmark1_checkbox.png")}
                            alt=""
                          />
                        </label>
                        <p>{t("checkout_emailNews2")}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="checkout_left_info_shipping_address">
                <div className="checkout_left_info_flex checkout_left_info_flex_title">
                  <div className="checkout_left_info_flex_left">
                    <h1 className="checkout_left_info_title 1">{t("SHIPPING ADDRESS")}</h1>
                  </div>
                  <div className="checkout_left_info_flex_right"></div>
                </div>
               
                {isLoggedIn && hasAddress && userAddressRender.length > 0 && userAddress.length > 0  && (
                  <div className="checkout_left_info_flex">
                    <div className="checkout_left_info_flex_all">
                      <div className="checkout_ship_to_card">
                        <div className="checkout_ship_to_row">
                          <div className="checkout_ship_to_row_inner">
                            <h2 className="checkout_ship_to_label" style={{ textAlign: "start" }}>{t("Ship to")}</h2>
                            <div className="checkout_ship_to_summary" style={{ textAlign: "start" , padding: "0 0.5rem" }}>
                              {addressSummary ? (
                                <>
                                  <div className="checkout_ship_to_name">
                                    {addressSummary.line1}
                                  </div>
                                  {addressSummary.line2 && (
                                    <div className="checkout_ship_to_address">
                                      {addressSummary.line2}
                                    </div>
                                  )}
                                  {addressSummary.line3 && (
                                    <div className="checkout_ship_to_contact">
                                      {addressSummary.line3}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div className="checkout_ship_to_placeholder">
                                  {t("Select a different address")}
                                </div>
                              )}
                            </div>
                            <button
                              type="button"
                              className="checkout_ship_to_toggle"
                              aria-expanded={addressSelectorExpanded}
                              aria-controls="checkout-ship-to-content"
                              onClick={() => setAddressSelectorExpanded((prev) => !prev)}
                            >
                              <svg viewBox="0 0 14 14" focusable="false" aria-hidden="true">
                                <path
                                  d="M3.5 5.5L7 9l3.5-3.5"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="1.2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        {addressSelectorExpanded && (
                          <div
                            id="checkout-ship-to-content"
                            className="checkout_ship_to_content"
                          >
                            <div className="checkout_ship_to_options" role="group">
                              {userAddress.map((addr) => {
                                const formatted = formatUserAddressLines(addr);
                                const option = userAddressRender.find(
                                  (item) => item.value === addr["CustomerAddressId"]
                                );
                                const addressId = addr["CustomerAddressId"];
                                const isSelected = isAddressOptionSelected(addressId);
                                return (
                                  <div
                                    key={addressId}
                                    className={`checkout_ship_to_option${
                                      isSelected ? " selected" : ""
                                    }`}
                                  >
                                    <div className="checkout_ship_to_option_label">
                                      <div className="radio_style radio_style_type checkout_ship_to_radio">
                                        <input
                                          className="radio"
                                          type="radio"
                                          id={`checkout-address-${addressId}`}
                                          name="checkoutShippingAddress"
                                          checked={isSelected}
                                          onChange={() =>
                                            option && handleAddressOptionSelect(option)
                                          }
                                        />
                                        <label
                                          htmlFor={`checkout-address-${addressId}`}
                                          className="checkout_ship_to_option_text"
                                          style={{ paddingTop: "0" }}
                                        >
                                          <span className="checkout_ship_to_option_primary">
                                            {formatted.line1}
                                          </span>
                                          {formatted.line2 && (
                                            <span className="checkout_ship_to_option_primary">
                                              {formatted.line2}
                                            </span>
                                          )}
                                          {formatted.line3 && (
                                            <span className="checkout_ship_to_option_secondary">
                                              {formatted.line3}
                                            </span>
                                          )}
                                          {/* {addr["IsDefault"] && (
                                            <span className="checkout_ship_to_default_badge">
                                              {t("Default")}
                                            </span>
                                          )} */}
                                        </label>
                                      </div>
                                    </div>
                                    {isSelected && (
                                      <div className="checkout_ship_to_option_menu_wrap">
                                        <button
                                          type="button"
                                          className="checkout_ship_to_menu_btn"
                                          aria-label={t("More address actions")}
                                          aria-expanded={addressMenuOpenId === addressId}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setAddressMenuOpenId((prev) =>
                                              prev === addressId ? null : addressId
                                            );
                                          }}
                                        >
                                          <svg
                                            viewBox="0 0 14 14"
                                            focusable="false"
                                            aria-hidden="true"
                                          >
                                            <circle cx="7" cy="3" r="1" fill="currentColor" />
                                            <circle cx="7" cy="7" r="1" fill="currentColor" />
                                            <circle cx="7" cy="11" r="1" fill="currentColor" />
                                          </svg>
                                        </button>
                                        {addressMenuOpenId === addressId && (
                                          <div
                                            className="checkout_ship_to_menu"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            <button
                                              type="button"
                                              className="checkout_ship_to_menu_item"
                                              onClick={() => handleAddressEdit(addr)}
                                            >
                                              {t("Edit")}
                                            </button>
                                            <button
                                              type="button"
                                              className="checkout_ship_to_menu_item checkout_ship_to_menu_delete"
                                              onClick={() => handleAddressDelete(addr)}
                                            >
                                              {t("Delete")}
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                              {userAddressRender
                                .filter((item) => item.value === -1)
                                .map((option) => (
                                  <button
                                    key={option.value}
                                    type="button"
                                    className="checkout_ship_to_add_btn"
                                    onClick={() => handleAddressOptionSelect(option)}
                                  >
                                    <svg viewBox="0 0 14 14" focusable="false" aria-hidden="true">
                                      <path
                                        d="M7 2.5v9M2.5 7h9"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.2"
                                        strokeLinecap="round"
                                      />
                                    </svg>
                                    <span>{option.label}</span>
                                  </button>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
            
                {
                  userAddress.length === 0 && (
                    <>

<div className="checkout_left_info_flex">
  <div className="checkout_left_info_flex_left">
    <input
      type="text"
      placeholder={t("First Name*")}
      className="form-control"
      name="Name1"
      value={address1["Name"]}
      onChange={(e) => {
        setAddress(1, "Name", e.target.value);
      }}
    />
    {firstNotExist && (
      <div className="input_not_valid">{t("First Name Required.")}</div>
    )}
  </div>
  <div className="checkout_left_info_flex_right">
    <input
      type="text"
      placeholder={t("Last Name*")}
      className="form-control"
      name="Last1"
      value={address1["Last"]}
      onChange={(e) => {
        setAddress(1, "Last", e.target.value);
      }}
    />
    {lastNotExist && (
      <div className="input_not_valid">{t("Last Name Required.")}</div>
    )}
  </div>
</div>
<div className="checkout_left_info_flex">
  <div className="checkout_left_info_flex_left">
    <div className="select_container">
      <Select
        className="select"
        placeholder={t("State*")}
        portal={document.body}
        dropdownPosition="bottom"
        dropdownHandle={false}
        dropdownGap={0}
        values={selectedState}
        dropdownRenderer={({ props, state, methods }) => (
          <CustomDropdownWithSearch props={props} state={state} methods={methods} />
        )}
        contentRenderer={({ props, state, methods }) => (
          <CustomControl props={props} state={state} methods={methods} />
        )}
        onChange={(selected) => {
          if (selected.length) {
            setSelectedState(selected);
            getCities(pageLanguage, selected[0].value);
          }
        }}
        options={states}
      />
    </div>
  </div>
  <div className="checkout_left_info_flex_right">
    <div className="select_container">
      <Select
        className="select"
        placeholder={t("City*")}
        portal={document.body}
        dropdownPosition="bottom"
        dropdownHandle={false}
        dropdownGap={0}
        values={selectedCity}
        dropdownRenderer={({ props, state, methods }) => (
          <CustomDropdownWithSearch props={props} state={state} methods={methods} />
        )}
        contentRenderer={({ props, state, methods }) => (
          <CustomControl props={props} state={state} methods={methods} />
        )}
        onChange={(selected) => {
          if (selected.length) {
            setSelectedCity(selected);
          }
        }}
        options={cities}
      />
    </div>
  </div>
</div>
<div className="checkout_left_info_flex">
  <div className="checkout_left_info_flex_all">
    <input
      type="text"
      placeholder={t("Address 1*")}
      className="form-control"
      name="Address11"
      value={getEditAddressDisplayValue(address1["Address1"], true)}
      onChange={(e) => {
        setAddressFromInput(1, "Address1", e.target.value);
      }}
    />
    {address1NotExist && (
      <div className="input_not_valid">{t("Address1 Required.")}</div>
    )}
  </div>
</div>
<div className="checkout_left_info_flex">
  <div className="checkout_left_info_flex_all">
    <input
      type="text"
      placeholder={t("Address 2")}
      className="form-control"
      name="Address21"
      value={getEditAddressDisplayValue(address1["Address2"], true)}
      onChange={(e) => {
        setAddressFromInput(1, "Address2", e.target.value);
      }}
    />
  </div>
</div>
<div className="checkout_left_info_flex">
  <div className="checkout_left_info_flex_left 13">
    <input
      type="text"
      placeholder={t("Zip Code*")}
      className="form-control"
      name="ZipCode1"
      value={getEditAddressDisplayValue(address1["ZipCode"])}
      onChange={(e) => {
        const normalizedZip = normalizeAddressInputValue(e.target.value);
        setAddress(1, "ZipCode", normalizedZip);
      }}
    />
    {zipCodeNotExist && (
      <div className="input_not_valid">{t("ZipCode Required.")}</div>
    )}
  </div>
  <div className="checkout_left_info_flex_right">
    <input
      type="text"
      placeholder={t("Mobile*")}
      className="form-control"
      name="PhoneNumber1"
      value={getEditAddressDisplayValue(address1["PhoneNumber"])}
      onChange={(e) => {
        const normalizedPhone = normalizeAddressInputValue(e.target.value, true);
        setAddress(1, "PhoneNumber", normalizedPhone);
        validateNumber(normalizedPhone);
      }}
    />
    {mobileNotExist && (
      <div className="input_not_valid">
        {mobileError[pageLanguage][mobileErrorState]["error"]}
      </div>
    )}
  </div>
</div>
{/* این قسمت حذف نشود بعدا باید کار شود  */}
{/* {!isLoggedIn && (
  <div className="checkout_left_info_shipping_agree">
    <div className="checkout_left_info_flex">
      <div className="checkout_left_info_flex_checkbox">
        <input
          type="checkbox"
          checked={passwordsEnable}
          onChange={(e) => {
            setPasswordsEnable(e.target.checked);
            setAddress2Enable(false);
            if (!e.target.checked) {
              resetCheckoutPasswordFields();
            }
          }}
          id="passwordEnable"
        />
        <label htmlFor="passwordEnable" className="checkbox_label 2">
          <img
            className="checkbox_label_img checkmark1 img-fluid"
            src={require("../Images/public/checkmark1_checkbox.png")}
            alt=""
          />
        </label>
        <p>{t("checkout_confirm")}</p>
      </div>
    </div>
  </div>
)} */}
{passwordsEnable && (
  <div className="checkout_left_info_flex">
    <div className="checkout_left_info_flex_left">
      <div className="checkout_password_field_wrap">
        <input
          ref={checkoutPasswordRef}
          type={showCheckoutPassword ? "text" : "password"}
          placeholder={t("Password*")}
          className="form-control form-control-password"
          name="checkout-new-password"
          autoComplete="new-password"
          data-lpignore="true"
          data-1p-ignore="true"
          readOnly
          value={loginInfo.password}
          onFocus={(e) => e.target.removeAttribute("readOnly")}
          onChange={(e) => {
            checkoutPasswordEditedRef.current = true;
            let temp = JSON.parse(JSON.stringify(loginInfo));
            temp.password = e.target.value.replace(/\s/g, "");
            temp.password = temp.password.replace(/[^0-9A-Za-z\s]/g, "");
            setLoginInfo(temp);
            if (temp.password === temp.passwordConfirm) setPasswordMatch(true);
            else setPasswordMatch(false);
            setAddress2Enable(false);
            checkPasswordStrength(temp.password);
          }}
          onClick={() => setShowPasswordValidation(true)}
        />
        <button
          type="button"
          className="checkout_password_toggle_btn"
          aria-label={
            showCheckoutPassword ? t("Hide password") : t("Show password")
          }
          onClick={() => setShowCheckoutPassword((prev) => !prev)}
        >
          {showCheckoutPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
      {showPasswordValidation && (
        <div className="input_not_valid_password ">
          <h2 className="input_not_valid_password_title">
            {t("Your password must contain:")}
          </h2>
          <ul className="input_not_valid_password_list">
            <li
              className={
                "input_not_valid_password_item " +
                (passwordValidation.count
                  ? "input_not_valid_password_item_check"
                  : "")
              }
            >
              <span>
                {passwordValidation.count && (
                  <img
                    className="checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1.png")}
                    alt=""
                  />
                )}
                {t("password_required_text1")}
              </span>
            </li>
            <li
              className={
                "input_not_valid_password_item " +
                (passwordValidation.lowercase
                  ? "input_not_valid_password_item_check"
                  : "")
              }
            >
              <span>
                {passwordValidation.lowercase && (
                  <img
                    className="checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1.png")}
                    alt=""
                  />
                )}
                {t("password_required_text2")}
              </span>
            </li>
            <li
              className={
                "input_not_valid_password_item " +
                (passwordValidation.uppercase
                  ? "input_not_valid_password_item_check"
                  : "")
              }
            >
              <span>
                {passwordValidation.uppercase && (
                  <img
                    className="checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1.png")}
                    alt=""
                  />
                )}
                {t("password_required_text3")}
              </span>
            </li>
            <li
              className={
                "input_not_valid_password_item " +
                (passwordValidation.numbers
                  ? "input_not_valid_password_item_check"
                  : "")
              }
            >
              <span>
                {passwordValidation.numbers && (
                  <img
                    className="checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1.png")}
                    alt=""
                  />
                )}
                {t("password_required_text4")}
              </span>
            </li>
          </ul>
        </div>
      )}
    </div>
    <div className="checkout_left_info_flex_right">
      <div className="checkout_password_field_wrap">
        <input
          ref={checkoutPasswordConfirmRef}
          type={showCheckoutPasswordConfirm ? "text" : "password"}
          placeholder={t("Confirm Password*")}
          className="form-control form-control-password"
          name="checkout-confirm-password"
          autoComplete="new-password"
          data-lpignore="true"
          data-1p-ignore="true"
          readOnly
          value={loginInfo.passwordConfirm}
          onFocus={(e) => e.target.removeAttribute("readOnly")}
          onChange={(e) => {
            checkoutPasswordEditedRef.current = true;
            let temp = JSON.parse(JSON.stringify(loginInfo));
            temp.passwordConfirm = e.target.value;
            setLoginInfo(temp);
            if (temp.password === temp.passwordConfirm) setPasswordMatch(true);
            else setPasswordMatch(false);
            setAddress2Enable(false);
          }}
        />
        <button
          type="button"
          className="checkout_password_toggle_btn"
          aria-label={
            showCheckoutPasswordConfirm ? t("Hide password") : t("Show password")
          }
          onClick={() => setShowCheckoutPasswordConfirm((prev) => !prev)}
        >
          {showCheckoutPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>
  </div>
)}
{/*  
{passwordsEnable && passwordMatch && (
  <div className="checkout_left_info_shipping_address">
    <div className="checkout_left_info_flex">
      <div className="checkout_left_info_flex_radios">
        <div className="radio_style">
          <input
            className="radio"
            type="radio"
            checked={!address2Enable}
            name="checkout_address"
            id="1"
            onClick={(e) => {
              setAddress2Enable(false);
            }}
          />
          <label htmlFor="1">{t("SHIP TO ABOVE ADDRESS")}</label>
        </div>
        <div className="radio_style">
          <input
            className="radio"
            type="radio"
            checked={address2Enable}
            name="checkout_address"
            id="2"
            onClick={(e) => {
              setAddress2Enable(true);
            }}
          />
          <label htmlFor="2">
            {t("SHIP TO NEW ADDRESS")}
            <br />
          </label>
        </div>
      </div>
    </div>
  </div>
)}
  */}
                    </>
                )}


              </div>

              {passwordsEnable && passwordMatch && address2Enable && (
                <div className="checkout_left_info_shipping_address checkout_left_info_shipping_address2">
                  <div className="checkout_left_info_flex">
                    <div className="checkout_left_info_flex_left">
                      <input
                        type="text"
                        placeholder={t("First Name*")}
                        className="form-control"
                        name="Name2"
                        value={address2["Name"]}
                        onChange={(e) => {
                          setAddress(2, "Name", e.target.value);
                        }}
                      />
                    </div>
                    <div className="checkout_left_info_flex_right">
                      <input
                        type="text"
                        placeholder={t("Last Name*")}
                        className="form-control"
                        name="Last2"
                        value={address2["Last"]}
                        onChange={(e) => {
                          setAddress(2, "Last", e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="checkout_left_info_flex">
                    <div className="checkout_left_info_flex_left">
                      <div className="select_container">
                        <Select
                          className="select"
                          placeholder={t("State*")}
                          portal={document.body}
                          dropdownPosition="bottom"
                          dropdownHandle={false}
                          dropdownGap={0}
                          values={selectedState}
                          dropdownRenderer={({ props, state, methods }) => (
                            <CustomDropdownWithSearch
                              props={props}
                              state={state}
                              methods={methods}
                            />
                          )}
                          contentRenderer={({ props, state, methods }) => (
                            <CustomControl props={props} state={state} methods={methods} />
                          )}
                          onChange={(selected) => {
                            if (selected.length) {
                              setSelectedState(selected);
                              getCities(pageLanguage, selected[0].value);
                            }
                          }}
                          options={states}
                        />
                      </div>
                    </div>
                    <div className="checkout_left_info_flex_right">
                      <div className="select_container">
                        <Select
                          className="select"
                          placeholder={t("City*")}
                          portal={document.body}
                          dropdownPosition="bottom"
                          dropdownHandle={false}
                          dropdownGap={0}
                          values={selectedCity}
                          dropdownRenderer={({ props, state, methods }) => (
                            <CustomDropdownWithSearch
                              props={props}
                              state={state}
                              methods={methods}
                            />
                          )}
                          contentRenderer={({ props, state, methods }) => (
                            <CustomControl props={props} state={state} methods={methods} />
                          )}
                          onChange={(selected) => {
                            if (selected.length) {
                              setSelectedCity(selected);
                            }
                          }}
                          options={cities}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="checkout_left_info_flex">
                    <div className="checkout_left_info_flex_all">
                      <input
                        type="text"
                        placeholder={t("Address 1*")}
                        className="form-control"
                        name="Address12"
                        value={getEditAddressDisplayValue(address2["Address1"], true)}
                        onChange={(e) => {
                          setAddressFromInput(2, "Address1", e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="checkout_left_info_flex">
                    <div className="checkout_left_info_flex_all">
                      <input
                        type="text"
                        placeholder={t("Address 2*")}
                        className="form-control"
                        name="Address22"
                        value={getEditAddressDisplayValue(address2["Address2"], true)}
                        onChange={(e) => {
                          setAddressFromInput(2, "Address2", e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="checkout_left_info_flex">
                    <div className="checkout_left_info_flex_left">
                      <input
                        type="text"
                        placeholder={t("Zip Code*")}
                        className="form-control"
                        name="ZipCode2"
                        value={getEditAddressDisplayValue(address2["ZipCode"])}
                        onChange={(e) => {
                          setAddressFromInput(2, "ZipCode", e.target.value);
                        }}
                      />
                    </div>
                    <div className="checkout_left_info_flex_right">
                      <input
                        type="text"
                        placeholder={t("Phone Number*")}
                        className="form-control"
                        name="PhoneNumber2"
                        value={getEditAddressDisplayValue(address2["PhoneNumber"])}
                        onChange={(e) => {
                          setAddressFromInput(2, "PhoneNumber", e.target.value, true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="checkout_left_payment" style={{paddingTop:"0.1rem"}}>
            <div className="checkout_left_info_flex_left" style={{padding:"1rem 0"}}>
                  <h1 className="checkout_left_info_title 12" style={{marginTop:"0.95rem"}}>
                    {
                      shippingMethods.length > 1 ? t("shipping_methods") : t("shipping_method")
                    }
                    </h1>
                </div>
              <div className="checkout_left_info_flex">
                <div className="checkout_left_info_flex_all">
                  {(() => {
                   
                    const selectedShippingMethod = getSelectedShippingMethod();
                    const selectedShippingLabel = selectedShippingMethod
                      ? getShippingMethodLabel(selectedShippingMethod)
                      : "";
                    return (
                      <div className="checkout_shipping_card">
                        <div className="checkout_shipping_row">
                          <button
                            type="button"
                            className="checkout_shipping_row_inner"
                            aria-expanded={shippingMethodExpanded}
                            aria-controls="checkout-shipping-content"
                            disabled={shippingMethods.length === 0}
                            onClick={() => {
                              if (shippingMethods.length > 0) {
                                setShippingMethodExpanded((prev) => !prev);
                              }
                            }}
                          >
                            {shippingMethods.length > 0  &&  <h2 className="checkout_ship_to_label">{t("shipping")}</h2>}
                          
                           
                              <div
                                className={`checkout_shipping_summary${
                                  selectedShippingMethod ? "" : " checkout_shipping_summary_empty"
                                }`}
                              >
                                {selectedShippingMethod ? (
                                  <>
                                    {selectedShippingLabel}
                                    <span className="checkout_shipping_summary_sep"> · </span>
                                    {formatShippingMethodPrice(selectedShippingMethod)}
                                  </>
                                ) : (
                                  t("Enter-your-shipping-method")
                                )}
                              </div>
                         
                            {/* {!shippingMethodExpanded && (
                              <div
                                className={`checkout_shipping_summary${
                                  selectedShippingMethod ? "" : " checkout_shipping_summary_empty"
                                }`}
                              >
                                {selectedShippingMethod ? (
                                  <>
                                    {selectedShippingLabel}
                                    <span className="checkout_shipping_summary_sep"> · </span>
                                    {formatShippingMethodPrice(selectedShippingMethod)}
                                  </>
                                ) : (
                                  t("Enter-your-shipping-method")
                                )}
                              </div>
                            )} */}
                            {shippingMethods.length > 0 && (
                              <span className="checkout_shipping_toggle">
                                <svg viewBox="0 0 14 14" focusable="false" aria-hidden="true">
                                  <path
                                    d="M3.5 5.5L7 9l3.5-3.5"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </span>
                            )}
                          </button>
                        </div>
                        {shippingMethodExpanded && shippingMethods.length > 0 && (
                          <div
                            id="checkout-shipping-content"
                            className="checkout_shipping_content"
                          >
                            <div className="checkout_shipping_options" role="radiogroup">
                              {shippingMethods.map((method, index) => {
                                const label = getShippingMethodLabel(method);
                                if (!label) return null;
                                const methodKey = getShippingMethodKey(method, index);
                                const isSelected =
                                  getEffectiveSelectedShippingMethodKey() === methodKey;
                                const delivery = getShippingMethodDeliveryTime(method);
                                const priceValue = getShippingMethodPriceValue(method);
                                return (
                                  <div
                                    key={methodKey}
                                    className={`checkout_shipping_option${
                                      isSelected ? " selected" : ""
                                    }`}
                                  >
                                    <div className="checkout_shipping_option_label">
                                      <div className="radio_style radio_style_type checkout_shipping_radio">
                                        <input
                                          className="radio"
                                          type="radio"
                                          id={`checkout-shipping-method-${methodKey}`}
                                          name="checkoutShippingMethod"
                                          checked={isSelected}
                                          onChange={() =>
                                            handleShippingMethodSelect(method, methodKey)
                                          }
                                        />
                                        <label
                                          htmlFor={`checkout-shipping-method-${methodKey}`}
                                          className="checkout_shipping_option_text"
                                          style={{ paddingTop: "0" }}
                                        >
                                          <span className="checkout_shipping_option_name">
                                            {label}
                                          </span>
                                          {delivery && (
                                            <span className="checkout_shipping_option_delivery">
                                              ({delivery})
                                            </span>
                                          )}
                                        </label>
                                      </div>
                                      <span
                                        className={`checkout_shipping_option_price${
                                          priceValue === 0 ? " checkout_shipping_option_price_free" : ""
                                        }`}
                                      >
                                        {formatShippingMethodPrice(method)}
                                      </span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
              {totalPrice + shippingPrice > 0 && (
                <div className="checkout_left_info_flex checkout_left_info_flex_title">
                  <div className="checkout_left_info_flex_left">
                    <h1 className="checkout_left_info_title" style={{paddingTop:"1rem"}}>
                      {t("PLEASE SELECT A PAYMENT METHOD")}
                    </h1>
                  </div>
                  <div className="checkout_left_info_flex_right"></div>
                </div>
              )}

              {totalPrice + shippingPrice > 0 && (
                <div className="checkout_left_info_flex checkout_left_info_flex_title">
                  <div className="checkout_left_info_flex_all">
                    <ul className="box-list gateway-list">
                      <li className={bank === 1 ? "selected" : ""}>
                        <input
                          className="radio"
                          type="radio"
                          value={bank === 1}
                          name="bank"
                          id="bank1"
                          onClick={(e) => {
                            setBank(1);
                          }}
                        />
                        <label htmlFor="bank1">
                          <img
                            src={require("../Images/public/bank-saman.png")}
                            className="img-fluid"
                            alt=""
                          />
                        </label>
                      </li>
                      <li className={bank === 2 ? "selected" : ""}>
                        <input
                          className="radio"
                          type="radio"
                          value={bank === 2}
                          name="bank"
                          id="bank2"
                          onClick={(e) => {
                            setBank(2);
                          }}
                        />
                        <label htmlFor="bank2">
                          <img
                            src={require("../Images/public/bank-mellat.png")}
                            className="img-fluid"
                            alt=""
                          />
                        </label>
                      </li>
                      <li className={bank === 3 ? "selected" : ""}>
                        <input
                          className="radio"
                          type="radio"
                          value={bank === 3}
                          name="bank"
                          id="bank3"
                          onClick={(e) => {
                            setBank(3);
                          }}
                        />
                        <label htmlFor="bank3">
                          <img
                            src={require("../Images/public/bank-parsian.png")}
                            className="img-fluid"
                            alt=""
                          />
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="checkout_left_info_flex checkout_left_info_flex_title">
                <div className="checkout_left_info_flex_left">
                  {totalPrice + shippingPrice > 0 && (
                    <button
                      className="checkout_payment_button 1"
                      onClick={handleContinueToPayment}
                      disabled={paymentContinuing}
                    >
                      {t("Continue to Payment")}
                    </button>
                  )}
                  {totalPrice + shippingPrice === 0 && (
                    <button className="checkout_payment_button 2" onClick={() => validateInputs()}>
                      {t("Submit Order")}
                    </button>
                  )}
                </div>
                <div className="checkout_left_info_flex_right">
                  <Link
                    to={"/" + pageLanguage + "/Basket"}
                    className="checkout_payment_button_return"
                  >
                    <span>{t("Return to Bag")}</span>
                    <i className="arrow-back" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="checkout_right">
          <div className="checkout_right_container">
            <ul className="checkout_right_cart_items scrool-bar 1">
              {hasApiCartProducts ? (
                isLoggedIn ? (
                  <ProductTowComponent
                    product2={product2}
                    pageLanguage={pageLanguage}
                    NumberToPersianWord={NumberToPersianWord}
                    convertToPersian={convertToPersian}
                    t={t}
                    GetPrice={GetPrice}
                    isTabletOrMobile={isTabletOrMobile}
                    ContextAwareToggleViewDetails={ContextAwareToggleViewDetails}
                    capitalizeFirstLetter={capitalizeFirstLetter}
                  />
                ) : (
                  <GuestProductList
                    productGuest={productGuest}
                    pageLanguage={pageLanguage}
                    NumberToPersianWord={NumberToPersianWord}
                    convertToPersian={convertToPersian}
                    t={t}
                    GetPrice={GetPrice}
                    isTabletOrMobile={isTabletOrMobile}
                    ContextAwareToggleViewDetails={ContextAwareToggleViewDetails}
                    capitalizeFirstLetter={capitalizeFirstLetter}
                  />
                )
              ) : (
                guestDraperyProducts.length > 0 && (
                  <DraperyComponent
                    drapery={guestDraperyProducts}
                    pageLanguage={pageLanguage}
                    NumberToPersianWord={NumberToPersianWord}
                    convertToPersian={convertToPersian}
                    t={t}
                    GetPrice={GetPrice}
                    isTabletOrMobile={isTabletOrMobile}
                    ContextAwareToggleViewDetails={ContextAwareToggleViewDetails}
                    capitalizeFirstLetter={capitalizeFirstLetter}
                  />
                )
              )}
              <SwatchesComponent
                swatches={swatches}
                pageLanguage={pageLanguage}
                NumberToPersianWord={NumberToPersianWord}
                t={t}
                GetPrice={GetPrice}
                isTabletOrMobile={isTabletOrMobile}
              />
            </ul>
            <div className="checkout_right_discount">
              <div className="checkout_right_discount_container">
                <input
                  type="text"
                  className="checkout_right_discount_input"
                  placeholder={t("Discount Code")}
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
                <div className="checkout_right_discount_apply_container">
                  <button
                    className="checkout_right_discount_apply"
                    disabled={discount === ""}
                    onClick={() => checkDiscount()}
                  >
                    {t("Apply")}
                  </button>
                </div>
              </div>
              {discountErr && discountErr !== "" && (
                <div className="discount_err_container">
                  <h2>{discountErr}</h2>
                </div>
              )}
              <div className="discount_applied_container">{discountList}</div>
            </div>
            <div className="checkout_right_price_detail">
              <span className="checkout_right_price_sub payment_price_detail">
                <h3>{t("PRODUCT TOTAL")}</h3>
                {priceTotal && (
                  <h4>
                    {subTotalPrice >= 0
                      ? GetPrice(
                          priceTotal["TotalAmount"],
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )
                      : t("FREE")}
                  </h4>
                )}
                {!priceTotal && (
                  <h4>
                    {subTotalPrice >= 0
                      ? GetPrice(
                          subTotalPrice + totalPriceBuy,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )
                      : t("FREE")}
                  </h4>
                )}
              </span>
              {installPrice > 0 && (
                <span className="checkout_right_price_sub payment_price_detail 1">
                  <h3>{t("INSTALLATION SERVICES")}</h3>
                  <h4>
                    {installPrice > 0
                      ? GetPrice(installPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : t("FREE")}
                  </h4>
                </span>
              )}
              {transportPrice > 0 && (
                <span className="checkout_right_price_sub payment_price_detail">
                  <h3>{t("TRANSPORTATION FEE")}</h3>
                  <h4>
                    {transportPrice > 0
                      ? GetPrice(transportPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : t("FREE")}
                  </h4>
                </span>
              )}
          
              {(!noShipping || swatches.length > 0) && (
                <span className="checkout_right_price_sub payment_price_detail">
                  <h3>{t("SHIPPING")}</h3>
                  <h4>
                    {shippingPrice > 0
                      ? GetPrice(shippingPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : t("FREE")}
                  </h4>
                </span>
              )}
            </div>
            <div className="checkout_right_price_detail">
              <span className="checkout_right_price_total payment_price_detail">
                <h3>{t("TOTAL")}</h3>

                {priceTotal && (
                  <h4>
                    {subTotalPrice >= 0
                      ? GetPrice(
                          priceTotal["TotalAmount"] - totalSaving,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )
                      : t("Free")}
                  </h4>
                )}
                {!priceTotal && (
                  <h4>
                    {totalPrice + shippingPrice >= 0
                      ? GetPrice(
                          totalPrice + shippingPrice + totalPriceBuy,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )
                      : t("Free")}
                  </h4>
                )}
              </span>
              {totalSaving > 0 && (
                <span className="checkout_right_price_sub payment_price_detail">
                  <h3>{t("TOTAL SAVING")}</h3>
                  <h4>
                    {totalSaving > 0
                      ? GetPrice(totalSaving, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : t("FREE")}
                  </h4>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal side_login_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={showSideLoginModal}
        onHide={() => setShowSideLoginModal(false)}
        id="checkout_side_login_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ModalLogin setShowSideLoginModal={setShowSideLoginModal} />
        </Modal.Body>
      </Modal>

      <Modal
        centered
        show={showEditAddressModal}
        onHide={() => {
          setShowEditAddressModal(false);
          setEditAddressMode("edit");
        }}
        dialogClassName={`checkout_edit_address_modal mediumSizeModal mediumSizeModal_address
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
      >
        <Modal.Header closeButton>
          <Modal.Title>
           
            <div className="checkout_left_info_flex_left"
            style={{width:"100%"}}
             >
                    <h1 className="checkout_left_info_title">
                    {editAddressMode === "add" ? t("ADD ADDRESS") : t("Edit address")}
                    </h1>
                  </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{padding:"1rem 0.45rem"}}>
          <div className="checkout_edit_address_form">
            <div className="checkout_left_info_flex">
              <div className="checkout_left_info_flex_left">
                <input
                  type="text"
                  placeholder={t("First Name*")}
                  className="form-control"
                  value={editAddressForm.Name}
                  onChange={(e) => setEditAddressField("Name", e.target.value)}
                />
              </div>
              <div className="checkout_left_info_flex_right">
                <input
                  type="text"
                  placeholder={t("Last Name*")}
                  className="form-control"
                  value={editAddressForm.Last}
                  onChange={(e) => setEditAddressField("Last", e.target.value)}
                />
              </div>
            </div>
            <div className="checkout_left_info_flex">
              <div className="checkout_left_info_flex_left">
                <select
                  className="form-control checkout_native_select"
                  value={
                    editSelectedState[0]?.value != null && editSelectedState[0]?.value !== ""
                      ? String(editSelectedState[0].value)
                      : ""
                  }
                  onChange={(e) => {
                    const nextValue = e.target.value;
                    const selected = states.find(
                      (item) => String(item.value) === String(nextValue)
                    );
                    if (selected) {
                      setEditSelectedState([selected]);
                      setEditAddressField("StateId", selected.value);
                      setEditSelectedCity([]);
                      setEditAddressField("CityId", "");
                      getEditCities(pageLanguage, selected.value);
                    }
                  }}
                >
                  <option value="" disabled>
                    {t("State*")}
                  </option>
                  {states.map((state) => (
                    <option key={state.value} value={String(state.value)}>
                      {state.label}
                    </option>
                  ))}
                  {editSelectedState.length &&
                    !states.some(
                      (s) => String(s.value) === String(editSelectedState[0].value)
                    ) && (
                      <option value={String(editSelectedState[0].value)}>
                        {editSelectedState[0].label}
                      </option>
                    )}
                </select>
              </div>
              <div className="checkout_left_info_flex_right">
                <select
                  className="form-control checkout_native_select"
                  value={
                    editSelectedCity[0]?.value != null && editSelectedCity[0]?.value !== ""
                      ? String(editSelectedCity[0].value)
                      : ""
                  }
                  disabled={!editCities.length && !editSelectedCity.length}
                  onChange={(e) => {
                    const nextValue = e.target.value;
                    const selected = editCities.find(
                      (item) => String(item.value) === String(nextValue)
                    );
                    if (selected) {
                      setEditSelectedCity([selected]);
                      setEditAddressField("CityId", selected.value);
                    }
                  }}
                >
                  <option value="" disabled>
                    {t("City*")}
                  </option>
                  {editCities.map((city) => (
                    <option key={city.value} value={String(city.value)}>
                      {city.label}
                    </option>
                  ))}
                  {editSelectedCity.length &&
                    !editCities.some(
                      (c) => String(c.value) === String(editSelectedCity[0].value)
                    ) && (
                      <option value={String(editSelectedCity[0].value)}>
                        {editSelectedCity[0].label}
                      </option>
                    )}
                </select>
              </div>
            </div>
            <div className="checkout_left_info_flex">
              <div className="checkout_left_info_flex_all">
                <input
                  type="text"
                  placeholder={t("Address 1*")}
                  className="form-control"
                  value={getEditAddressDisplayValue(editAddressForm.Address1, true)}
                  onChange={(e) =>
                    setEditAddressField("Address1", normalizeAddressInputValue(e.target.value))
                  }
                />
              </div>
            </div>
            <div className="checkout_left_info_flex">
              <div className="checkout_left_info_flex_all">
                <input
                  type="text"
                  placeholder={t("Address 2")}
                  className="form-control"
                  value={getEditAddressDisplayValue(editAddressForm.Address2, true)}
                  onChange={(e) =>
                    setEditAddressField("Address2", normalizeAddressInputValue(e.target.value))
                  }
                />
              </div>
            </div>
            <div className="checkout_left_info_flex">
              <div className="checkout_left_info_flex_left 11">
                <input
                  type="text"
                  placeholder={t("Zip Code*")}
                  className="form-control"
                  value={getEditAddressDisplayValue(editAddressForm.ZipCode)}
                  onChange={(e) =>
                    setEditAddressField("ZipCode", normalizeAddressInputValue(e.target.value))
                  }
                />
              </div>
              <div className="checkout_left_info_flex_right">
                <input
                  type="text"
                  placeholder={t("Mobile*")}
                  className="form-control"
                  value={getEditAddressDisplayValue(editAddressForm.PhoneNumber)}
                  onChange={(e) =>
                    setEditAddressField(
                      "PhoneNumber",
                      normalizeAddressInputValue(e.target.value, true)
                    )
                  }
                />
              </div>
            </div>
            <div className="checkout_left_info_shipping_agree">
              <div className="checkout_left_info_flex">
                <div className="checkout_left_info_flex_checkbox">
                  <label className="account_label">
                    <input
                      type="checkbox"
                      checked={editAddressForm.IsDefault}
                      id={
                        editAddressMode === "add"
                          ? "checkoutAddIsDefault"
                          : "checkoutEditIsDefault"
                      }
                      onChange={(e) => setEditAddressField("IsDefault", e.target.checked)}
                    />
                    <label
                      htmlFor={
                        editAddressMode === "add"
                          ? "checkoutAddIsDefault"
                          : "checkoutEditIsDefault"
                      }
                      className="checkbox_label"
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {t("Set as default address")}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="checkout_edit_address_footer">
          <button
            type="button"
            className="checkout_edit_address_cancel"
            onClick={() => {
              setShowEditAddressModal(false);
              setEditAddressMode("edit");
            }}
          >
            {t("CANCEL")}
          </button>
          <button
            type="button"
            className="btn btn-new-dark checkout_edit_address_save"
            disabled={editAddressSaving}
            onClick={saveEditAddress}
          >
            {editAddressMode === "add" ? t("ADD ADDRESS") : t("Save address")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        centered
        dialogClassName={`deleteAddress_modal checkout_delete_address_modal mediumSizeModal mediumSizeModal_address ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={showDeleteAddressModal}
        onHide={() => {
          setShowDeleteAddressModal(false);
          setDeleteAddressId(null);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="checkout_left_info_flex_left" style={{ width: "100%" }}>
              <h1 className="checkout_left_info_title"
              style={{padding:"0 0.2rem"}}
              >{t("DELETE ADDRESS")}</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{padding:"1rem 0.45rem"}}>
          <p className="delete_address_confirm_text">
            {getDeleteAddressConfirmMessage()}
            </p>
        </Modal.Body>
        <Modal.Footer className="checkout_edit_address_footer">
          <button
            type="button"
            className="checkout_edit_address_cancel"
            onClick={() => {
              setShowDeleteAddressModal(false);
              setDeleteAddressId(null);
            }}
          >
            {t("CANCEL")}
          </button>
          <button
            type="button"
            className="btn btn-danger checkout_delete_address_confirm"
            style={{ backgroundColor: "#ca6667" }}
            onClick={confirmDeleteAddress}
          >
            {t("DELETE")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        centered
        dialogClassName={`deleteAddress_modal checkout_delete_address_modal mediumSizeModal mediumSizeModal_address ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={showPaymentSuccessModal}
        onHide={handlePaymentSuccessModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="checkout_left_info_flex_left" style={{ width: "100%" }}>
              <h1 className="checkout_left_info_title" style={{ padding: "0 0.2rem" }}>
                {t("checkout_payment_success_title")}
              </h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1rem 0.45rem" }}>
          <p className="delete_address_confirm_text">{t("checkout_payment_success_message")}</p>
        </Modal.Body>
        <Modal.Footer className="checkout_edit_address_footer">
          <button
            type="button"
            className="btn btn-new-dark checkout_edit_address_save"
            onClick={handlePaymentSuccessModalClose}
          >
            {t("OK")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Checkout;